import useApiManager from 'networking/ApiManager';
import React, { useEffect, useState, useRef } from 'react';
import {
  CommonAlert,
  CoreButton,
  CoreInputBox,
  CoreTextArea,
  PrescriptionMedicines,
  Select2DropDown,
  TagSelectPicker,
  ReactSelect,
} from 'whealth-core-web/components';
import { useLocation, useParams } from 'react-router-dom';
import { Button, DatePicker, Input, Modal } from 'rsuite';
import { formulationData, splitArrData, splitArrObjData } from '../Helper';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import './quill.css';
import Select from 'react-select';
import { user } from 'whealth-core-web/assets/images';
import { ConstructionIcon } from 'lucide-react';

function AddPrescriptionPMSForm(props) {
  const {
    onClick,
    setErrors,
    errors,
    dynamicPerscriptionData,
    selectedDepartment,
    userRole,
    setDynamicPerscriptionData,
    setAlertType,
    setIsShowAlert,
    isShowAlert,
    alertType,
    isNivanCareTeam,
    paf,
    pafData,
    pid,
    isPublish
  } = props;
  const location = useLocation();
  const [fieldErrors, setFieldErrors] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState();
  const [selectedSiteDiagnosis, setSelectedSiteDiagnosis] = useState(null);
  const [diagnosisRemark, setDiagnosisRemark] = useState(null);
  const [diagnosisData, setDiagnosisData] = useState([]);

  const [selectedDefDiagnosis, setSelectedDefDiagnosis] = useState();
  const [selectedSiteDefDiagnosis, setSelectedSiteDefDiagnosis] = useState(null);
  const [diagnosisDefRemark, setDiagnosisDefRemark] = useState(null);
  const [defDiagnosisData, setDefDiagnosisData] = useState([]);

  const [medications, setMedications] = useState([
    { value: 'Steroids', label: 'Steroids' },
    { value: 'Anti-coagulants', label: 'Anti-coagulants' },
    { value: 'Other', label: 'Other' },
  ]);
  const [currentMedication, setCurrentMedication] = useState(null);
  const [medicationRemark, setMedicationRemark] = useState(null);
  const [medicationData, setMedicationData] = useState([]);

  const [investigationsTest, setInvestigationsTest] = useState([
    {
      value: 'CBC, Vit D, Vit B-12, Blood sugar - Fasting, PP, HbA1C, Thyroid Function Test, Kidney Function Test',
      label: 'CBC, Vit D, Vit B-12, Blood sugar - Fasting, PP, HbA1C, Thyroid Function Test, Kidney Function Test',
    },
    {
      value: 'Prothrombin Time/INR, APTT, Viral markers - HIV, HbsAg, HCV, Blood Sugar Random',
      label: 'Prothrombin Time/INR, APTT, Viral markers - HIV, HbsAg, HCV, Blood Sugar Random',
    },
    { value: 'Anti CCP', label: 'Anti CCP' },
    { value: 'Blood sugar fasting', label: 'Blood sugar fasting' },
    { value: 'Blood sugar PP', label: 'Blood sugar PP' },
    { value: 'Blood Urea', label: 'Blood Urea' },
    { value: 'Complete Blood Count', label: 'Complete Blood Count' },
    { value: 'HBA1C', label: 'HBA1C' },
    { value: 'Hemoglobin', label: 'Hemoglobin' },
    { value: 'HLA B27', label: 'HLA B27' },
    { value: 'Neutrophil count', label: 'Neutrophil count' },
    { value: 'Platelet count', label: 'Platelet count' },
    { value: 'PT/ INR, APTT', label: 'PT/ INR, APTT' },
    { value: 'RA factor', label: 'RA factor' },
    { value: 'Serum Creatinine', label: 'Serum Creatinine' },
    { value: 'Serum Vitamin D', label: 'Serum Vitamin D' },
    { value: 'Thyroid function test', label: 'Thyroid function test' },
    { value: 'TLC', label: 'TLC' },
    { value: 'Viral markers- Anti HbsAg', label: 'Viral markers- Anti HbsAg' },
    { value: 'Viral markers- Anti HCV', label: 'Viral markers- Anti HCV' },
    { value: 'Viral markers- HIV', label: 'Viral markers- HIV' },
    { value: 'Vitamin B12', label: 'Vitamin B12' },
    { value: 'Other', label: 'Other' },
  ]);
  const [investigationImaging, setInvestigationImaging] = useState([
    { value: 'Dexascan', label: 'Dexascan' },
    { value: 'Footscan', label: 'Footscan' },
    { value: 'MRI', label: 'MRI' },
    { value: 'MRI - Knee', label: 'MRI - Knee' },
    { value: 'MRI - Lumbosacral Spine', label: 'MRI - Lumbosacral Spine' },
    { value: 'MRI - Sacro Iliac Joint', label: 'MRI - Sacro Iliac Joint' },
    { value: 'MRI Cervical Spine', label: 'MRI Cervical Spine' },
    { value: 'USG', label: 'USG' },
    { value: 'X-Ray - Cervical Spine', label: 'X-Ray - Cervical Spine' },
    { value: 'X-ray - Sacro Iliac Joint', label: 'X-ray - Sacro Iliac Joint' },
    { value: 'X-Ray Knee AP, Lateral, Standing', label: 'X-Ray Knee AP, Lateral, Standing' },
    { value: 'X-ray lumbosacral Spine', label: 'X-ray lumbosacral Spine' },
    { value: 'Other', label: 'Other' },
  ]);

  const [diagnosisMaster, setDiagnosisMaster] = useState([])
  const [diagnosisEditMaster, setDiagnosisEditMaster] = useState([])
  const [defdiagnosisEditMaster, setDefDiagnosisEditMaster] = useState([])

  // const [diagnosisMaster, setDiagnosisMaster] = useState([
  //   { value: 'Achilles Tendinopathy', label: 'Achilles Tendinopathy' },
  //   { value: 'Acromio-Clavicular Joint Arthropathy', label: 'Acromio-Clavicular Joint Arthropathy' },
  //   { value: 'Ankylosing Spondylitis', label: 'Ankylosing Spondylitis' },
  //   { value: 'Avascular Necrosis of femur head', label: 'Avascular Necrosis of femur head' },
  //   { value: 'Back Musculoskeletal injury (strain/sprain)', label: 'Back Musculoskeletal injury (strain/sprain)' },
  //   { value: "Baker's cyst", label: "Baker's cyst" },
  //   { value: 'Biceps tendinopathy', label: 'Biceps tendinopathy' },
  //   { value: 'Bursitis', label: 'Bursitis' },
  //   { value: 'Calcaneal Spurs', label: 'Calcaneal Spurs' },
  //   { value: 'Carpel Tunnel Syndrome', label: 'Carpel Tunnel Syndrome' },
  //   { value: 'Cervical canal stenosis', label: 'Cervical canal stenosis' },
  //   { value: 'Cervicogenic Headache', label: 'Cervicogenic Headache' },
  //   { value: 'Chondromalacia patellae', label: 'Chondromalacia patellae' },
  //   { value: 'Chronic non-specific low back pain', label: 'Chronic non-specific low back pain' },
  //   { value: 'Coccydynia', label: 'Coccydynia' },
  //   { value: 'Dequervains Teno Synovitis', label: 'Dequervains Teno Synovitis' },
  //   { value: 'Discogenic pain', label: 'Discogenic pain' },
  //   { value: 'Facet Joint arthropathy - cervical spine', label: 'Facet Joint arthropathy - cervical spine' },
  //   { value: 'Facet Joint arthropathy - dorsal spine', label: 'Facet Joint arthropathy - dorsal spine' },
  //   { value: 'Facet Joint arthropathy - lumbar spine', label: 'Facet Joint arthropathy - lumbar spine' },
  //   { value: 'Fibromyalgia', label: 'Fibromyalgia' },
  //   { value: 'Gluteus Medius Tendinopathy', label: 'Gluteus Medius Tendinopathy' },
  //   { value: 'Greater Occipital Neuralgia', label: 'Greater Occipital Neuralgia' },
  //   { value: 'Herpetic neuralgia', label: 'Herpetic neuralgia' },
  //   { value: 'Hip Osteoarthritis', label: 'Hip Osteoarthritis' },
  //   { value: 'Ilio-Tibial Band Syndrome', label: 'Ilio-Tibial Band Syndrome' },
  //   { value: 'Infection', label: 'Infection' },
  //   { value: 'Labral Tear', label: 'Labral Tear' },
  //   { value: 'Lateral Epicondylitis', label: 'Lateral Epicondylitis' },
  //   { value: 'Ligament Sprain', label: 'Ligament Sprain' },
  //   { value: 'Ligament Tear ACL Complete', label: 'Ligament Tear ACL Complete' },
  //   { value: 'Ligament Tear ACL Partial', label: 'Ligament Tear ACL Partial' },
  //   { value: 'Ligament Tear Other', label: 'Ligament Tear Other' },
  //   { value: 'Ligament Tear PCL Complete', label: 'Ligament Tear PCL Complete' },
  //   { value: 'Ligament Tear PCL Partial', label: 'Ligament Tear PCL Partial' },
  //   { value: 'Loose bodies - Knee', label: 'Loose bodies - Knee' },
  //   { value: 'Lumbar canal stenosis', label: 'Lumbar canal stenosis' },
  //   { value: 'Lumbar spondylolisthesis', label: 'Lumbar spondylolisthesis' },
  //   { value: 'Malignant Pain', label: 'Malignant Pain' },
  //   { value: 'Medial Epicondylitis', label: 'Medial Epicondylitis' },
  //   { value: 'Meniscal injury', label: 'Meniscal injury' },
  //   { value: 'Migraine', label: 'Migraine' },
  //   { value: 'Myofascial Pain Syndrome', label: 'Myofascial Pain Syndrome' },
  //   { value: 'Osteoarthritis knee Bilateral', label: 'Osteoarthritis knee Bilateral' },
  //   { value: 'Osteoarthritis knee Left', label: 'Osteoarthritis knee Left' },
  //   { value: 'Osteoarthritis knee Right', label: 'Osteoarthritis knee Right' },
  //   { value: 'Paraspinal Muscle Spasm', label: 'Paraspinal Muscle Spasm' },
  //   { value: 'Patellar Tendinopathy', label: 'Patellar Tendinopathy' },
  //   { value: 'PIVD - cervical spine with radiculopathy', label: 'PIVD - cervical spine with radiculopathy' },
  //   { value: 'PIVD - cervical spine without radiculopathy', label: 'PIVD - cervical spine without radiculopathy' },
  //   { value: 'PIVD - dorsal spine with radiculopathy', label: 'PIVD - dorsal spine with radiculopathy' },
  //   { value: 'PIVD - dorsal spine without radiculopathy', label: 'PIVD - dorsal spine without radiculopathy' },
  //   { value: 'PIVD - lumbar spine with radiculopathy', label: 'PIVD - lumbar spine with radiculopathy' },
  //   { value: 'PIVD -lumbar spine without radiculopathy', label: 'PIVD -lumbar spine without radiculopathy' },
  //   { value: 'Plantar Fascitis', label: 'Plantar Fascitis' },
  //   { value: 'Pyriformis Syndrome', label: 'Pyriformis Syndrome' },
  //   { value: 'Reduced bone density- Osteopenia / Osteoporosis', label: 'Reduced bone density- Osteopenia / Osteoporosis' },
  //   { value: 'Retrocalcaneal Bursitis', label: 'Retrocalcaneal Bursitis' },
  //   { value: 'Rheumatoid arthritis', label: 'Rheumatoid arthritis' },
  //   { value: 'Rotator cuff injury - Complete Tear', label: 'Rotator cuff injury - Complete Tear' },
  //   { value: 'Rotator cuff injury - Partial Tear', label: 'Rotator cuff injury - Partial Tear' },
  //   { value: 'Sacroiliac Joint Dysfunction', label: 'Sacroiliac Joint Dysfunction' },
  //   { value: 'Scoliosis', label: 'Scoliosis' },
  //   { value: 'Shoulder Adhesive Capsulitis', label: 'Shoulder Adhesive Capsulitis' },
  //   { value: 'Shoulder osteoarthritis', label: 'Shoulder osteoarthritis' },
  //   { value: 'Frozen Shoulder', label: 'Frozen Shoulder' },
  //   { value: 'Stress Fractures', label: 'Stress Fractures' },
  //   { value: 'Subacromial / Subdeltoid Bursitis', label: 'Subacromial / Subdeltoid Bursitis' },
  //   { value: 'Subacromial Impingement', label: 'Subacromial Impingement' },
  //   { value: 'Supraspinatus tendinopathy', label: 'Supraspinatus tendinopathy' },
  //   { value: 'Temporo-Mandibular Joint dysfunction', label: 'Temporo-Mandibular Joint dysfunction' },
  //   { value: 'Tension Type Headache', label: 'Tension Type Headache' },
  //   { value: 'Tibialis Posterior Tendinopathy', label: 'Tibialis Posterior Tendinopathy' },
  //   { value: 'Trauma', label: 'Trauma' },
  //   { value: 'Triangular fibrocartilage complex (TFCC) Injury', label: 'Triangular fibrocartilage complex (TFCC) Injury' },
  //   { value: 'Trigeminal Neuralgia', label: 'Trigeminal Neuralgia' },
  //   { value: 'Trigger Finger', label: 'Trigger Finger' },
  //   { value: 'Trochanteric Bursitis', label: 'Trochanteric Bursitis' },
  //   { value: 'Vertebral fracture', label: 'Vertebral fracture' },
  //   { value: 'Other', label: 'Other' },
  // ]);


  const [painSite, setPainSite] = useState([
    { value: 'Face / Head Pain', label: 'Face / Head Pain' },
    { value: 'Shoulder Pain', label: 'Shoulder Pain' },
    { value: 'Elbow Pain', label: 'Elbow Pain' },
    { value: 'Wrist Pain', label: 'Wrist Pain' },
    { value: 'Neck Pain', label: 'Neck Pain' },
    { value: 'Back Pain', label: 'Back Pain' },
    { value: 'Hip Pain', label: 'Hip Pain' },
    { value: 'Knee Pain', label: 'Knee Pain' },
    { value: 'Foot / Ankle Pain', label: 'Foot / Ankle Pain' },
    { value: 'Other', label: 'Other' },
]);

const diagnosisMasterData = {
  "Face / Head Pain": [
    "Migraine",
    "Cervicogenic Headache",
    "Trigeminal Neuralgia",
    "Tension Type Headache",
    "Greater Occipital Neuralgia",
    "Temporo-Mandibular Joint Dysfunction",
    "Other"
  ],

  "Shoulder Pain": [
    "Shoulder osteoarthritis",
    "Frozen Shoulder",
    "Acromio-Clavicular Joint Arthropathy",
    "Rotator cuff injury - Partial Tear",
    "Rotator cuff injury - Complete Tear",
    "Supraspinatus tendinopathy",
    "Biceps tendinopathy",
    "Labral Tear",
    "Subacromial / Subdeltoid Bursitis",
    "Subacromial Impingement",
    "Other"
  ],

  "Elbow Pain": [
    "Lateral Epicondylitis",
    "Medial Epicondylitis",
    "Other"
  ],

  "Wrist Pain": [
    "Carpel Tunnel Syndrome",
    "Dequervains Teno Synovitis",
    "Trigger Finger",
    "Triangular Fibrocartilage Complex (TFCC) Injury",
    "Other"
  ],

  "Neck Pain": [
    "PIVD - cervical spine without radiculopathy",
    "PIVD - cervical spine with radiculopathy",
    "Facet Joint arthropathy - cervical spine",
    "Cervical canal stenosis",
    "Muscle Spasm",
    "Other"
  ],

  "Back Pain": [
    "Discogenic Pain",
    "PIVD - dorsal spine without radiculopathy",
    "PIVD - dorsal spine with radiculopathy",
    "Facet Joint arthropathy - dorsal spine",
    "Facet Joint arthropathy - lumbar spine",
    "PIVD - lumbar spine without radiculopathy",
    "PIVD - lumbar spine with radiculopathy",
    "Lumbar spondylolisthesis",
    "Lumbar canal stenosis",
    "Sacroiliac Joint Dysfunction",
    "Coccydynia",
    "Vertebral fracture",
    "Scoliosis",
    "Paraspinal Muscle Spasm",
    "Back Musculoskeletal injury",
    "Other"
  ],

  "Hip Pain": [
    "Pyriformis Syndrome",
    "Hip Osteoarthritis",
    "Avascular Necrosis of Femur Head",
    "Gluteus Medius Tendinopathy",
    "Ilio-Tibial Band Syndrome",
    "Trochanteric Bursitis",
    "Other"
  ],

  "Knee Pain": [
    "Osteoarthritis Knee Right",
    "Osteoarthritis Knee Left",
    "Osteoarthritis Knee Bilateral",
    "Chondromalacia Patellae",
    "Ligament Tear ACL Partial",
    "Ligament Tear ACL Complete",
    "Ligament Tear PCL Partial",
    "Ligament Tear PCL Complete",
    "Ligament Tear Other",
    "Meniscal injury",
    "Baker’s cyst",
    "Patellar Tendinopathy",
    "Loose bodies - Knee",
    "Other"
  ],

  "Foot / Ankle Pain": [
    "Retrocalcaneal Bursitis",
    "Plantar Fasciitis",
    "Achilles Tendinopathy",
    "Calcaneal Spurs",
    "Tibialis Posterior Tendinopathy",
    "Stress Fractures",
    "Morton’s Neuroma",
    "Other"
  ],

  "Other": [
    "Fibromyalgia",
    "Myofascial Pain Syndrome",
    "Herpetic Neuralgia",
    "Reduced Bone Density - Osteopenia / Osteoporosis",
    "Malignant Pain",
    "Rheumatoid arthritis",
    "Ankylosing Spondylitis",
    "Trauma",
    "Infection",
    "Bursitis",
    "Ligament Sprain",
    "Other"
  ]
};

const treatmentMasterData = {
  "Other": [
    "LA+Steroid",
    "Dry Needling",
    "Surgery needed",
    "Tendon sheath or ligament intervention",
    "Autologous Biologics Implantation",
    "Other"
  ],

  "Face / Head Pain": [
    "Sphenopalatine ganglion block",
    "Sphenopalatine ganglion radio frequency therapy",
    "Botox injection",
    "Greater Occipital Nerve Block",
    "Greater Occipital Nerve radio frequency therapy",
    "Lesser Occipital Nerve block",
    "Lesser Occipital Nerve radio frequency ablation",
    "RF ablation gasserion ganglion (Trigeminal Ganglion)",
    "Neurolysis - Maxillary Nerve",
    "Neurolysis - Mandibular Nerve",
    "Supraorbital / Supratrochlear nerve block",
    "Other"
  ],

  "Shoulder Pain": [
    "Shoulder Intra-articular injection - steroid",
    "Shoulder Intra-articular injection - Platelet Rich Plasma",
    "Shoulder Intra-articular injection - Hydrodistension (with Prolotherapy)",
    "Intra-articular Hydrodistention (with saline)",
    "Shoulder Platelet Rich Plasma Injection for soft tissue injury",
    "Suprascapular Nerve block",
    "Suprascapular Nerve Radio Frequency Therapy",
    "Subacromial / Subdeltoid Bursa Injection",
    "Other"
  ],

  "Wrist Pain": [
    "Median Nerve Hydrodissection",
    "PRP for Triangular fibrocartilage complex (TFCC)",
    "PRP for wrist Tenosynovitis",
    "Ganglion Aspiration and Injection",
    "Other"
  ],

  "Elbow Pain": [
    "LA + Steroid Injection for lateral epicondylitis",
    "LA + Steroid Injection for medial epicondylitis",
    "PRP Injection for lateral epicondylitis",
    "PRP Injection for medial epicondylitis",
    "Other"
  ],

  "Neck Pain": [
    "Epidural Injection - Cervical",
    "Cervical facet joint intrarticular intervention",
    "Medial Branch Block",
    "Medial Branch Block Radio Frequency Therapy",
    "Other"
  ],

  "Back Pain": [
    "Epidural Injection - Lumbar",
    "Epidural Injection - Caudal",
    "Selective Spinal Nerve Root Block",
    "Pulsed Radio Frequency Ablation of DRG",
    "Thoracic facet joint intrarticular intervention",
    "Lumbar facet joint intrarticular intervention",
    "Medial Branch Block",
    "Medial Branch Block Radio Frequency Therapy",
    "Sacroiliac joint intrarticular intervention",
    "Ganglion Impar block",
    "Ganglion Impar Radio Frequency Therapy",
    "Coccyx- Pericoccygeal infiltration",
    "Endoscopic Discectomy",
    "Biacuplasty",
    "Kyphoplasty",
    "Vertebroplasty",
    "Other"
  ],

  "Hip Pain": [
    "Hip Intra-articular injection - Platelet Rich Plasma",
    "Hip Intra-articular Steroid + LA Injection",
    "Hip Intra Bursal Injection",
    "Other"
  ],

  "Knee Pain": [
    "Knee Intra-articular injection - steroid",
    "Knee Intra-articular injection - Platelet Rich Plasma",
    "Knee Intra-articular injection - Growth Factor Concentrate",
    "Knee Intra-articular injection - iPRF",
    "Knee Intra-articular injection - Hyperacute Serum",
    "Knee Intra-articular injection - Hyaluronic Acid Derivatives",
    "Knee Intra-articular injection - Ozone",
    "RF Ablation Genicular Nerves of Knee",
    "Neurolysis Genicular Nerves of Knee",
    "Soft Tissue Injection - Prolotherapy around knee joint",
    "Baker’s Cyst Aspiration and Injection",
    "Other"
  ],

  "Foot / Ankle Pain": [
    "Ankle PRP Injection",
    "Medial Calcaneal Nerve Block",
    "Medial Calcaneal Nerve Radio Frequency Therapy",
    "Ankle Intra-articular Steroid + LA Injection",
    "Plantar Fascia LA+ steroid",
    "Plantar Fascia PRP",
    "Morton’s Neuroma intervention",
    "Other"
  ]
};


  const [test, setTest] = useState(null);
  const [testRemark, setTestRemark] = useState(null);
  const [imaging, setImgaging] = useState(null);
  const [imagingRemark, setImgagingRemark] = useState(null);
  const [investigationData, setInvestigationData] = useState([]);
  const [imagingData, setImagingData] = useState([]);
  const [investigationReport, setInvestigationReport] = useState(null);

  // Treatment
  const [treatmentMaster, setTreatmentMaster] = useState([])
  // const [treatmentMaster, setTreatmentMaster] = useState([
  //   { value: 'Ankle Intra-articular Steroid + LA Injection', label: 'Ankle Intra-articular Steroid + LA Injection' },
  //   { value: 'Ankle PRP Injection', label: 'Ankle PRP Injection' },
  //   { value: 'Autologous Biologics implantation', label: 'Autologous Biologics implantation' },
  //   { value: "Baker's Cyst Aspiration and Injection", label: "Baker's Cyst Aspiration and Injection" },
  //   { value: 'Biacuplasty', label: 'Biacuplasty' },
  //   { value: 'Botox injection', label: 'Botox injection' },
  //   { value: 'Cervical facet joint intrarticular intervention', label: 'Cervical facet joint intrarticular intervention' },
  //   { value: 'Coccyx - Ganglion Impar block', label: 'Coccyx - Ganglion Impar block' },
  //   { value: 'Coccyx - Ganglion Impar Radio Frequency Therapy', label: 'Coccyx - Ganglion Impar Radio Frequency Therapy' },
  //   { value: 'Coccyx- Pericoccygeal infiltration', label: 'Coccyx- Pericoccygeal infiltration' },
  //   { value: 'Dry Needling', label: 'Dry Needling' },
  //   { value: 'Endoscopic Discectomy', label: 'Endoscopic Discectomy' },
  //   { value: 'Epidural Injection - Caudal', label: 'Epidural Injection - Caudal' },
  //   { value: 'Epidural Injection - Cervical', label: 'Epidural Injection - Cervical' },
  //   { value: 'Epidural Injection - Lumbar', label: 'Epidural Injection - Lumbar' },
  //   { value: 'Ganglion Aspiration and Injection', label: 'Ganglion Aspiration and Injection' },
  //   { value: 'Greater Occipital Nerve Block', label: 'Greater Occipital Nerve Block' },
  //   { value: 'Greater Occipital Nerve radio frequency therapy', label: 'Greater Occipital Nerve radio frequency therapy' },
  //   { value: 'Hip Intra Bursal Injection', label: 'Hip Intra Bursal Injection' },
  //   { value: 'Hip Intra-articular injection - Platelet Rich Plasma', label: 'Hip Intra-articular injection - Platelet Rich Plasma' },
  //   { value: 'Hip Intra-articular Steroid + LA Injection', label: 'Hip Intra-articular Steroid + LA Injection' },
  //   { value: 'Intra-articular Hydrodistention (with saline)', label: 'Intra-articular Hydrodistention (with saline)' },
  //   { value: 'Knee Intra-articular injection - Growth Factor Concentrate', label: 'Knee Intra-articular injection - Growth Factor Concentrate' },
  //   { value: 'Knee Intra-articular injection - Hyaluronic Acid Derivatives', label: 'Knee Intra-articular injection - Hyaluronic Acid Derivatives' },
  //   { value: 'Knee Intra-articular injection - Hyperacute Serum', label: 'Knee Intra-articular injection - Hyperacute Serum' },
  //   { value: 'Knee Intra-articular injection - iPRF', label: 'Knee Intra-articular injection - iPRF' },
  //   { value: 'Knee Intra-articular injection - Ozone', label: 'Knee Intra-articular injection - Ozone' },
  //   { value: 'Knee Intra-articular injection - Platelet Rich Plasma', label: 'Knee Intra-articular injection - Platelet Rich Plasma' },
  //   { value: 'Knee Intra-articular injection - steroid', label: 'Knee Intra-articular injection - steroid' },
  //   { value: 'Kyphoplasty', label: 'Kyphoplasty' },
  //   { value: 'LA + Steroid Injection for lateral epicondylitis', label: 'LA + Steroid Injection for lateral epicondylitis' },
  //   { value: 'LA + Steroid Injection for medial epicondylitis', label: 'LA + Steroid Injection for medial epicondylitis' },
  //   { value: 'LA+Steroid', label: 'LA+Steroid' },
  //   { value: 'Lesser Occipital Nerve block', label: 'Lesser Occipital Nerve block' },
  //   { value: 'Lesser Occipital Nerve radio frequency ablation', label: 'Lesser Occipital Nerve radio frequency ablation' },
  //   { value: 'Lumbar facet joint intrarticular intervention', label: 'Lumbar facet joint intrarticular intervention' },
  //   { value: 'Medial Branch Block', label: 'Medial Branch Block' },
  //   { value: 'Medial Branch Block Radio Frequency Therapy', label: 'Medial Branch Block Radio Frequency Therapy' },
  //   { value: 'Medial Calcaneal Nerve Block', label: 'Medial Calcaneal Nerve Block' },
  //   { value: 'Medial Calcaneal Nerve Radio Frequency Therapy', label: 'Medial Calcaneal Nerve Radio Frequency Therapy' },
  //   { value: 'Median Nerve Hydrodissection (with saline)', label: 'Median Nerve Hydrodissection (with saline)' },
  //   { value: "Morton's Neuroma intervention", label: "Morton's Neuroma intervention" },
  //   { value: 'NEUROLYSIS - mandibular nerve', label: 'NEUROLYSIS - mandibular nerve' },
  //   { value: 'NEUROLYSIS - maxillary nerve', label: 'NEUROLYSIS - maxillary nerve' },
  //   { value: 'Neurolysis Genicular Nerves of Knee', label: 'Neurolysis Genicular Nerves of Knee' },
  //   { value: 'Plantar Fascia LA+ steroid', label: 'Plantar Fascia LA+ steroid' },
  //   { value: 'Plantar Fascia PRP', label: 'Plantar Fascia PRP' },
  //   { value: 'Prolotherapy for carpal tunnel syndrome', label: 'Prolotherapy for carpal tunnel syndrome' },
  //   { value: 'PRP for Triangular fibrocartilage complex (TFCC)', label: 'PRP for Triangular fibrocartilage complex (TFCC)' },
  //   { value: 'PRP for wrist Tenosynovitis', label: 'PRP for wrist Tenosynovitis' },
  //   { value: 'PRP Injection for lateral epicondylitis', label: 'PRP Injection for lateral epicondylitis' },
  //   { value: 'PRP Injection for medial epicondylitis', label: 'PRP Injection for medial epicondylitis' },
  //   { value: 'Pulsed Radio Frequency Ablation of DRG', label: 'Pulsed Radio Frequency Ablation of DRG' },
  //   { value: 'RF ablation gasserion ganglion (trigeminal ganglion)', label: 'RF ablation gasserion ganglion (trigeminal ganglion)' },
  //   { value: 'RF Ablation Genicular Nerves of Knee', label: 'RF Ablation Genicular Nerves of Knee' },
  //   { value: 'Sacroiliac joint denervation', label: 'Sacroiliac joint denervation' },
  //   { value: 'Sacroiliac joint intrarticular intervention', label: 'Sacroiliac joint intrarticular intervention' },
  //   { value: 'Selective Spinal Nerve Root Block', label: 'Selective Spinal Nerve Root Block' },
  //   {
  //     value: 'Shoulder Intra-articular injection - Hydrodistension (with Prolotherapy)',
  //     label: 'Shoulder Intra-articular injection - Hydrodistension (with Prolotherapy)',
  //   },
  //   { value: 'Shoulder Intra-articular injection - Platelet Rich Plasma', label: 'Shoulder Intra-articular injection - Platelet Rich Plasma' },
  //   { value: 'Shoulder Intra-articular injection - steroid', label: 'Shoulder Intra-articular injection - steroid' },
  //   { value: 'Shoulder Platelet Rich Plasma Injection for soft tissue injury', label: 'Shoulder Platelet Rich Plasma Injection for soft tissue injury' },
  //   { value: 'Soft Tissue Injection - Prolotherapy of Knee', label: 'Soft Tissue Injection - Prolotherapy of Knee' },
  //   { value: 'Sphenopalatine ganglion block', label: 'Sphenopalatine ganglion block' },
  //   { value: 'Sphenopalatine ganglion radio frequency therapy', label: 'Sphenopalatine ganglion radio frequency therapy' },
  //   { value: 'Subacromial / Subdeltoid Bursa Injection', label: 'Subacromial / Subdeltoid Bursa Injection' },
  //   { value: 'Supraorbital / Supratrochlear nerve block', label: 'Supraorbital / Supratrochlear nerve block' },
  //   { value: 'Suprascapular Nerve block', label: 'Suprascapular Nerve block' },
  //   { value: 'Suprascapular Nerve Radio Frequency Therapy', label: 'Suprascapular Nerve Radio Frequency Therapy' },
  //   { value: 'Surgery needed', label: 'Surgery needed' },
  //   { value: 'Tendon sheath or ligament intervention', label: 'Tendon sheath or ligament intervention' },
  //   { value: 'Thoracic facet joint intrarticular intervention', label: 'Thoracic facet joint intrarticular intervention' },
  //   { value: 'Vertebroplasty', label: 'Vertebroplasty' },
  //   { value: 'Other', label: 'Other' },
  // ]);

  const [treatmentOtherMaster, setTreatmentOtherMaster] = useState([
    { value: 'Alternate cold/hot fomentation', label: 'Alternate cold/hot fomentation' },
    { value: 'Brace', label: 'Brace' },
    { value: 'Custom sole', label: 'Custom sole' },
    { value: 'Hot Fomentation', label: 'Hot Fomentation' },
    { value: 'Ice Packs', label: 'Ice Packs' },
    { value: 'Orthotics', label: 'Orthotics' },
    { value: 'Physiotherapy', label: 'Physiotherapy' },
    { value: 'Rest', label: 'Rest' },
    { value: 'Walking Aid', label: 'Walking Aid' },
    { value: 'Other', label: 'Other' },
  ]);

  const [treatmentProcedure, setTreatmentProcedure] = useState(null);
  const [treatmentSite, setTreatmentSite] = useState(null);
  const [treatmentProcedureRemark, setTreatmentProcedureRemark] = useState(null);
  const [treatmentOther, setTreatmentOther] = useState(null);
  const [treatmentOtherRemark, setTreatmentOtherRemark] = useState(null);
  const [treatmentProcedureData, setTreatmentProcedureData] = useState([]);
  const [treatmentOtherData, setTreatmentOtherData] = useState([]);

  const [isDrugAllergies, setIsDrugAllergies] = useState(null);
  const [isMdt, setIsMdt] = useState(null);

  const [redAlertMaster, setRedAlertMaster] = useState([
    { value: 'Acute fever', label: 'Acute fever' },
    { value: 'Acute Trauma', label: 'Acute Trauma' },
    { value: 'Age of onset very old', label: 'Age of onset very old' },
    { value: 'Age of onset very young', label: 'Age of onset very young' },
    { value: 'Any Bowel / Bladder involvement', label: 'Any Bowel / Bladder involvement' },
    { value: 'Distal Neurovascular Deficit', label: 'Distal Neurovascular Deficit' },
    { value: 'Infection', label: 'Infection' },
    { value: 'Known Malignancy', label: 'Known Malignancy' },
    { value: 'Loss of appetite', label: 'Loss of appetite' },
    { value: 'None', label: 'None' },
    { value: 'Unintentional Weight Loss', label: 'Unintentional Weight Loss' },
  ]);
  const [redAlert, setRedAlert] = useState(null);
  const [redAlertRemark, setRedAlertRemark] = useState(null);
  const [redAlertData, setRedAlertData] = useState([]);

  const [treatmentMed, setTreatmentMed] = useState({
    medication_id: '',
    medication: '',
    brand: '',
    regimen: '',
    other_regimen: '',
    meal: '',
    duration: '',
    remark: '',
  });
  const [treatmentMedData, setTreatmentMedData] = useState([]);
  const [treatmentMedErr, setTreatmentMedErr] = useState('');
  const [medCompareOpen, setMedCompareOpen] = useState(false);
  const [medCompareItems, setMedCompareItems] = useState([]);

  const [mdtMaster, setMdtMaster] = useState([
    { value: 'Physio', label: 'Physio' },
    { value: 'Nutrition', label: 'Nutrition' },
    { value: 'Psych Consult', label: 'Psych Consult' },
  ]);

  const [external, setExternal] = useState([
    { id: 'Sx-Ortho', name: 'Sx-Ortho' },
    { id: 'Sx-Neuro', name: 'Sx-Neuro' },
    { id: 'Other', name: 'Other' },
  ]);

  const [allergiesMaster, setAllergiesMaster] = useState([
    { value: 'No Known Drug Allergy', label: 'No Known Drug Allergy' },
    { value: 'Lignocaine', label: 'Lignocaine' },
    { value: 'Other', label: 'Other' },
  ]);

  const [healthCondition, setHealthCondition] = useState('');
  const [healthConditionRemark, setHealthConditionRemark] = useState('');
  const [healthConditionData, setHealthConditionData] = useState([]);
  const [healthConditionMaster, setHealthConditionMaster] = useState([
    { value: 'Anxiety, mental health issues', label: 'Anxiety, mental health issues' },
    { value: 'Auto-immune conditions', label: 'Auto-immune conditions' },
    { value: 'Bleeding Disorder', label: 'Bleeding Disorder' },
    { value: 'Bronchial Asthma', label: 'Bronchial Asthma' },
    { value: 'Cardiac Illness', label: 'Cardiac Illness' },
    { value: 'Diabetes', label: 'Diabetes' },
    { value: 'History of malignancy', label: 'History of malignancy' },
    { value: 'Hypertension', label: 'Hypertension' },
    { value: 'Hypothyroidism', label: 'Hypothyroidism' },
    { value: 'Neurological concerns', label: 'Neurological concerns' },
    { value: 'None Declared', label: 'None Declared' },
    { value: 'Previous Surgery', label: 'Previous Surgery' },
    { value: 'Other', label: 'Other' },
  ]);

  const [drugA, setDrugA] = useState('');
  const [drugRemark, setDrugRemark] = useState('');
  const [drugData, setDrugData] = useState([]);

  const [vital, setVital] = useState({ bp: '', pulse: '', temperature: '', respiration: '', height: '', weight: '', bmi: '' });
  const [pms, setPms] = useState({
    vas_score: '',
    is_final: false,
    health_condition: [],
    previous_investigation_done: null, // Add this field for radio button
    previous_investigation_report: '',
    principal_complaints: '',
    pain_treatment_history: '',
    final_diagnosis: 0,
    next_checkin_date: null,
    drug_allergies: [],
    mdt_consults_advised: '',
    internal_note:'',
    external_consultation_referred:'',
  });
  const [healthConditionS, setHealthConditionS] = useState(null);

  const [medicineList, setMedicineList] = useState([]);
  const [medicineListId, setMedicineListId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [isCreateModal, setIsCreateModal] = useState();
  const [newMedicineName, setNewMedicineName] = useState('');
  const [medicineFormulation, setMedicineFormulation] = useState();
  const [medicineError, setMedicineError] = useState({});
  const [createMedicineIndex, setCreateMedicineIndex] = useState();
  const [principalComplaints, setPrincipalComplaints] = useState('');
  const [painTreatment, setPainTreatment] = useState('');
  const [weight, setWeight] = useState(''); // in kg
  const [feet, setFeet] = useState('');
  const [inches, setInches] = useState('');
  const [bmi, setBmi] = useState(null);
  const [open, setOpen] = useState(false);
  const [valueObj, setValueObj] = useState({ name: '', formulation: null , status: "transit" });
  const [medError, setMederror] = useState(null);
  const [medInfo, setMedInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);


  // FOR EDIT
  const [editDiagnosisIndex, setEditDiagnosisIndex] = useState(null);
  const [editDefDiagnosisIndex, setEditDefDiagnosisIndex] = useState(null);
  const [editTPIndex, setEditTPIndex] = useState(null);
  const [editMedIndex, setEditMedIndex] = useState(null);
  const [editTOIndex, setEditTOIndex] = useState(null);
  const [editTestIndex, setEditTestIndex] = useState(null);
  const [editImgIndex, setEditImgIndex] = useState(null);
  const [editCurMedIndex, setEditCurMedIndex] = useState(null);
  const [editDrugIndex, setEditDrugIndex] = useState(null);
  const [editHCIndex, setEditHCIndex] = useState(null);
  const [editRFIndex, setEditRFIndex] = useState(null);

  const startEditRedFlag = (index) => {
    setEditRFIndex(index);
  };

  const updateRedFlagField = (index, key, value) => {
    // setRedAlertData([...redAlertData, { redAlert: redAlert, remark: redAlertRemark }]);
    let updated = [...redAlertData];
    updated[index][key] = value;
    setRedAlertData(updated);
  };

  const startEditHealthCondition = (index) => {
    setEditHCIndex(index);
  };

  const updateHealthConditionField = (index, key, value) => {
    let updated = [...healthConditionData];
    updated[index][key] = value;
    setHealthConditionData(updated);
  };

  const startEditDrugAllergy = (index) => {
    setEditDrugIndex(index);
  };

  const updateDrugAllergyField = (index, key, value) => {
    // setDrugData([...drugData, { data: drugA, remark: drugRemark }]);
    let updated = [...drugData];
    updated[index][key] = value;
    setDrugData(updated);
  };

  const startEditCurrentMed = (index) => {
    setEditCurMedIndex(index);
  };

  const updateCurrentMedField = (index, key, value) => {
    let updated = [...medicationData];
    updated[index][key] = value;
    setMedicationData(updated);
  };

  const startEditImaging = (index) => {
    setEditImgIndex(index);
  };

  const updateImagingField = (index, key, value) => {
    const updated = [...imagingData];
    updated[index][key] = value;
    setImagingData(updated);
  };

  const startEditTest = (index) => {
    setEditTestIndex(index);
  };

  const updateTestField = (index, key, value) => {
    const updated = [...investigationData];
    updated[index][key] = value;
    setInvestigationData(updated);
  };

  const startEditMedicine = (index) => {
    setEditMedIndex(index);
  };

  const updateMedicineField = (index, key, value) => {
    let updated = [...treatmentMedData];
    updated[index][key] = value;
    setTreatmentMedData(updated);
  };

  const startEditTreatmentOther = (index) => {
    setEditTOIndex(index);
  };

  const updateTreatmentOtherField = (index, key, value) => {
    let updated = [...treatmentOtherData];
    updated[index][key] = value;
    setTreatmentOtherData(updated);
  };



  const startEditTP = (index,pain_site="") => {
    if(pain_site){
      const options = (treatmentMasterData[pain_site] || []).map(item => ({
        label: item,
        value: item,
      }));
      setTreatmentMaster(options);
    }
    setEditTPIndex(index);
  };
  const updateTPField = (index, key, value) => {
    let updated = [...treatmentProcedureData];
    updated[index][key] = value;
    setTreatmentProcedureData(updated);
  };

  const startEditDiagnosis = (item, index,pain_site = "") => {
    if(pain_site){
      const options = (diagnosisMasterData[pain_site] || []).map(item => ({
        label: item,
        value: item,
      }));
      setDiagnosisMaster(options);
    }
    setEditDefDiagnosisIndex(null);
    setEditDiagnosisIndex(index);
  };
  const startEditDefDiagnosis = (item, index,pain_site="") => {
    if(pain_site){
      const options = (diagnosisMasterData[pain_site] || []).map(item => ({
        label: item,
        value: item,
      }));
      setDiagnosisMaster(options);
    }
    setEditDiagnosisIndex(null);
    setEditDefDiagnosisIndex(index);
  };

  const updateDiagnosisField = (index, key, value) => {
    let updated = [...diagnosisData];
    updated[index][key] = value;
    setDiagnosisData(updated);
  };

  const updateDefDiagnosisField = (index, key, value) => {
    let updated = [...defDiagnosisData];
    updated[index][key] = value;
    setDefDiagnosisData(updated);
  };
  


  // end Edit
  const principalRef = useRef(null);
  const painRef = useRef(null);
  const scoreRef = useRef(null);
  const investigationReportRef = useRef(null); // Add ref for investigation report

  const duplicateId = location?.state?.id;
  let { id } = useParams();

  useEffect(() => {
    let nonDoctorTreatmentProcedureValues = [
      { value: 'Radio Frequence Ablation PRP Epidural', label: 'Radio Frequence Ablation PRP Epidural' },
      { value: 'Nerve Block Distectomy Intra Articular', label: 'Nerve Block Distectomy Intra Articular' },
      { value: 'Joint Injection Needling Surgery', label: 'Joint Injection Needling Surgery' },
    ];
    if (userRole !== 'doctor') {
      setTreatmentMaster((prev) => [...nonDoctorTreatmentProcedureValues, ...prev]);
    }
  }, [userRole]);

  useEffect(() => {
    console.log("pid" , pid , !pid)
    if (paf?.paf && !pid) {
      setVital({
        bp: paf.paf.bp || '',
        pulse: paf.paf.pulse || '',
        temperature: paf.paf.temperature || '',
        respiration: paf.paf.respiration || '',
        height: paf.paf.height_feet || '',
        height_inch : paf.paf.height_inch || '',
        weight: paf.paf.weight || '',
        bmi: paf.paf.bmi || ''
      });
      setWeight(paf.paf.weight || '');
      setFeet(paf.paf.height_feet || '');
      setInches(paf.paf.height_inch || '');
    }
    if (paf?.primary_pain && !pid) {
      setPms(prev => ({
        ...prev,
        vas_score: paf?.primary_pain?.pain_score || ''
      }));
    }
  },[paf]);

  const syncFromPaf = () => {

    const newVital = {
      bp: vital?.bp || paf?.paf?.bp || '',
      pulse: vital?.pulse || paf?.paf?.pulse || '',
      temperature: vital?.temperature || paf?.paf?.temperature || '',
      respiration: vital?.respiration || paf?.paf?.respiration || '',
      height: vital?.height || paf?.paf?.height_feet || '',
      height_inch: vital?.height_inch || paf?.paf?.height_inch || '',
      weight: vital?.weight || paf?.paf?.weight || '',
      bmi: vital?.bmi || paf?.paf?.bmi || ''
    };
  
    setVital(newVital); // async but OK
  
    setErrors({ prescription_medicines: [] });
    setFieldErrors([]);
  
    let prescription_data = {
      is_new: 1,
      sync:1,
    };
  
    if (dynamicPerscriptionData?.prescription_schema) {
      prescription_data.data = dynamicPerscriptionData.prescription_schema;
    }
  
    if (dynamicPerscriptionData?.enable_medicine) {
      prescription_data.prescription_medicines = dynamicPerscriptionData.prescription_medicines;
    }
  
    if (diagnosisData) {
      prescription_data.diagnosis_data = diagnosisData;
    }
  
    if (defDiagnosisData) {
      prescription_data.def_diagnosis_data = defDiagnosisData;
    }
  
    // ✅ Use newVital not state vital
    prescription_data.vital_data = newVital;
  
    if (pms) {
      prescription_data.pms_data = pms;
    }
  
    if (healthConditionData) {
      prescription_data.pms_data.health_condition = healthConditionData;
    }
  
    if (drugData) {
      prescription_data.pms_data.drug_allergies = drugData;
    }
  
    if (medicationData) {
      prescription_data.medication_data = medicationData;
    }
  
    if (investigationData) {
      prescription_data.investigation_data = investigationData;
    }
  
    if (treatmentProcedureData) {
      prescription_data.treatment_procedure_data = treatmentProcedureData;
    }
  
    if (treatmentOtherData) {
      prescription_data.treatment_other_data = treatmentOtherData;
    }
  
    if (imagingData) {
      prescription_data.imaging_data = imagingData;
    }
  
    if (redAlertData) {
      prescription_data.red_alert = redAlertData;
    }
  
    if (treatmentMedData) {
      prescription_data.treatment_medication = treatmentMedData;
    }
  
    let checkIserror = checkrequired(prescription_data.imaging_data);

    // Previous Investigation Done (Yes/No) is mandatory
    if (pms.previous_investigation_done !== 'yes' && pms.previous_investigation_done !== 'no') {
      setErrors((prev) => ({ ...prev, previous_investigation_done: 'Previous Investigation Done is required' }));
      checkIserror.isErrors = true;
    }

    // Validate Previous Investigation Report if Previous Investigation Done is "yes"
    if (pms.previous_investigation_done === 'yes') {
      const reportText = pms.previous_investigation_report?.replace(/<[^>]*>/g, '').trim(); // Strip HTML tags and trim
      if (!reportText || reportText === '') {
        setErrors((prev) => ({ ...prev, previous_investigation_report: 'Previous Investigation Report is required when Investigation Done is Yes' }));
        checkIserror.isErrors = true;
        // Scroll to the investigation report field
        setTimeout(() => {
          investigationReportRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }

    if (checkIserror.isErrors) {
      setFieldErrors(checkIserror.errors);
      scrollToFirstError();
    } else {
      onClick(prescription_data);
    }
  };
  const searchMedicines = (query, id) => {
    if (!dynamicPerscriptionData.searchData) {
      dynamicPerscriptionData.searchData = [];
    }
    setSearchValue(query);
    if (query?.trim()?.length > 2) {
      ApiClient.searchMedicines(query)
        .then((res) => {
          setMedicineList(res.data);
        })
        .catch((err) => console.log(err));
    }
  };

  const handleModalClose = () => {
    setOpen(false);
    setValueObj({ name: '', formulation: null });
    // setupdateData({});
    setMedInfo(null);
    setMederror(null);
  };

  const openModal = () => {
    setMederror(null);
    setMedInfo(null);
    setOpen(true);
  };

  useEffect(() => {
    ApiClient.prescriptionDoctorList(id, 'doctor').then((res) => {
      setDoctorList(res.data);
    });
  }, []);

  const addHealthConditon = () => {
    setHealthConditionData([...healthConditionData, { healthCondition: healthCondition, remark: healthConditionRemark }]);
    setHealthCondition('');
    setHealthConditionRemark('');
  };

  const removeHealthCondition = (index) => {
    setHealthConditionData(healthConditionData.filter((_, i) => i !== index));
  };

  const addDrugData = () => {
    setDrugData([...drugData, { data: drugA, remark: drugRemark }]);
    setDrugA('');
    setDrugRemark('');
  };

  const removeDrugData = (index) => {
    setDrugData(drugData.filter((_, i) => i !== index));
  };

  const addMedication = () => {
    // console.log(selectedDiagnosis,diagnosisRemark)
    setMedicationData([...medicationData, { current_medication: currentMedication, remark: medicationRemark }]);
    setCurrentMedication('');
    setMedicationRemark('');
  };
  const removeMedication = (index) => {
    setMedicationData(medicationData.filter((_, i) => i !== index));
  };

  const handleEnterPress = (e, method) => {
    if (e.key === 'Enter') {
      method();
    }
  };

  const addTreatmentMed = () => {
    if (treatmentMed?.medication && treatmentMed?.regimen) {
      setTreatmentMedData([...treatmentMedData, treatmentMed]);
      setTreatmentMed({
        medication: '',
        brand: '',
        regimen: '',
        other_regimen: '',
        meal: '',
        duration: '',
        remark: '',
      });
      setTreatmentMedErr('');
    } else {
      setTreatmentMedErr('Please check medication or regimen field is blank ');
    }
  };
  const removeTreatmentMed = (index) => {
    setTreatmentMedData(treatmentMedData.filter((_, i) => i !== index));
  };

  const addTest = () => {
    setInvestigationData([...investigationData, { investigationtests: test, remark: testRemark }]);
    setTest(null);
    setTestRemark(null);
  };
  const removeTest = (index) => {
    setInvestigationData(investigationData.filter((_, i) => i !== index));
  };

  const addTreatmentProcedure = () => {
    setTreatmentProcedureData([...treatmentProcedureData, { pain_site:treatmentSite ,treatmentprocedure: treatmentProcedure, remark: treatmentProcedureRemark }]);
    setTreatmentProcedure(null);
    setTreatmentProcedureRemark(null);
  };
  const removeTreatmentProcedure = (index) => {
    setTreatmentProcedureData(treatmentProcedureData.filter((_, i) => i !== index));
  };

  const addTreatmentOther = () => {
    setTreatmentOtherData([...treatmentOtherData, { treatmentother: treatmentOther, remark: treatmentOtherRemark }]);
    setTreatmentOther(null);
    setTreatmentOtherRemark(null);
  };
  const removeTreatmentOther = (index) => {
    setTreatmentOtherData(treatmentOtherData.filter((_, i) => i !== index));
  };

  // redAlertMaster
  const addRedAlert = () => {
    setRedAlertData([...redAlertData, { redAlert: redAlert, remark: redAlertRemark }]);
    setRedAlert(null);
    setRedAlertRemark(null);
  };
  const removeRedAlert = (index) => {
    setRedAlertData(redAlertData.filter((_, i) => i !== index));
  };

  const addImaging = () => {
    setImagingData([...imagingData, { investigationimaging: imaging, remark: imagingRemark }]);
    setImgaging(null);
    setImgagingRemark(null);
  };
  const removeImaging = (index) => {
    setImagingData(imagingData.filter((_, i) => i !== index));
  };

  const initialValues = {
    dosage: '000',
    medicine_id: '',
    duration: 0,
    frequency: '',
    note: '',
    meal_duration_unit: '',
    meal_duration_value: null,
    is_optional: false,
    medicine: { name: '' },
  };

  const ApiClient = useApiManager();

  // ----------------------------
  // Compare transcribed medicines against the medicine master list
  // ----------------------------
  const fetchMedicineComparisons = async (meds) => {
    if (!meds || meds.length === 0) return;
    const matchLists = await Promise.all(
      meds.map((item) =>
        ApiClient.fuzzySearchMedicines(item.medication, item.medication_id)
          .then((res) => res.data?.results || [])
          .catch(() => [])
      )
    );
    setMedCompareItems(
      meds.map((item, index) => ({
        original: item,
        matches: matchLists[index],
        selectedKey: 'original',
      }))
    );
    setMedCompareOpen(true);
  };

  const selectMedCompareOption = (itemIndex, selectedKey) => {
    setMedCompareItems((prev) =>
      prev.map((entry, index) => (index === itemIndex ? { ...entry, selectedKey } : entry))
    );
  };

  const closeMedCompareModal = () => {
    setMedCompareOpen(false);
    setMedCompareItems([]);
  };

  const applyMedicineComparisons = () => {
    const updated = medCompareItems.map((entry) => {
      if (entry.selectedKey === 'original') {
        return entry.original;
      }
      const match = entry.matches.find((m) => String(m.id) === entry.selectedKey);
      if (!match) return entry.original;
      return {
        ...entry.original,
        medication: match.name,
        medication_id: match.id,
        shorter_composition: match.shorter_composition || '',
      };
    });
    setTreatmentMedData(updated);
    closeMedCompareModal();
  };

  useEffect(() => {
    handleOnFocus();
  }, []);

  useEffect(() => {
    setMedicineListId(medicineListId);
  }, [medicineListId]);

  useEffect(() => {
    let data = dynamicPerscriptionData;
    if (data?.pms_data) {
      setPms(data?.pms_data);
    }
    if (data?.pms_data?.health_condition) {
      setHealthConditionData(data?.pms_data?.health_condition);
    }
    if (data?.pms_data?.drug_allergies) {
      setDrugData(data?.pms_data?.drug_allergies);
    }

    if (data?.vital_data) {
      setVital(data?.vital_data);
      setWeight(data?.vital_data?.weight || '');
      setFeet(data?.vital_data?.height || '');
      setInches(data?.vital_data?.height_inch || '');
    }
    if (data?.diagnosis_data) {
      setDiagnosisData(data?.diagnosis_data);
    }
    if (data?.def_diagnosis_data) {
      setDefDiagnosisData(data?.def_diagnosis_data);
    }
    if (data?.medication_data) {
      setMedicationData(data?.medication_data);
    }
    if (data?.investigation_data) {
      setInvestigationData(data?.investigation_data);
    }
    if (data?.treatment_procedure_data) {
      setTreatmentProcedureData(data?.treatment_procedure_data);
    }
    if (data?.treatment_other_data) {
      setTreatmentOtherData(data?.treatment_other_data);
    }
    if (data?.imaging_data) {
      setImagingData(data?.imaging_data);
    }
    if (data?.red_alert) {
      setRedAlertData(data?.red_alert);
    }
    if (data?.treatment_medication) {
      setTreatmentMedData(data?.treatment_medication);
      if (data.treatment_medication.length > 0) {
        fetchMedicineComparisons(data.treatment_medication);
      }
    }

    if (data?.pms_data?.mdt_consults_advised) {
      if (data?.pms_data?.mdt_consults_advised === 'External Consult') {
        setIsMdt('External Consult');
      } else {
        setIsMdt('Yes');
      }
    }
    if (data?.pms_data?.drug_allergies) {
      setIsDrugAllergies('Yes');
    }
    // if (data && data.isUpdate) {
    //   let tempData = { ...data };
    //   tempData.goal_id = data.goal.id;
    //   tempData.title = data.goal.title;

    //   if (tempData.prescription_medicines) {
    //     tempData.prescription_medicines.forEach((item, index) => {
    //       item.medicine_id = item?.medicine?.id;
    //       if (duplicateId) {
    //         delete item.id;
    //       }
    //     });
    //   }
    //   if (duplicateId) {
    //     delete tempData.status;
    //   }
    //   setDynamicPerscriptionData(tempData);
    // }
  }, []);

  const removeForm = (index) => {
    let dataObj = dynamicPerscriptionData;
    dataObj.prescription_medicines?.splice(index, 1);
    errors.prescription_medicines?.splice(index, 1);
    setErrors({ ...errors });
    setDynamicPerscriptionData((prevState) => {
      return { ...prevState, ...dataObj };
    });
  };

  const handleChangeFields = (data, key) => {
    dynamicPerscriptionData[key] = data;
    setDynamicPerscriptionData({ ...dynamicPerscriptionData });
  };

  const handleArrChange = (data, key, index) => {
    dynamicPerscriptionData.prescription_medicines[index][key] = data;
    setDynamicPerscriptionData({ ...dynamicPerscriptionData });
  };

  const handleArrChangeNewSearch = (data, key, index) => {
    dynamicPerscriptionData.prescription_medicines[index][key] = data;
    setDynamicPerscriptionData({ ...dynamicPerscriptionData });
  };

  const handleCheckBoxClick = (val, isChecked, index, arrvalues) => {
    let values = arrvalues;
    if (val && isChecked) {
      values[val] = '1';
    } else if (val && !isChecked) {
      values[val] = 0;
    }

    let arrToString = values.join('');
    dynamicPerscriptionData.prescription_medicines[index].dosage = arrToString;
    setDynamicPerscriptionData({ ...dynamicPerscriptionData });
  };

  const handleMealTime = (val, index) => {
    dynamicPerscriptionData.prescription_medicines[index].meal_time = val;
    if (val == 'with_meal') {
      dynamicPerscriptionData.prescription_medicines[index].meal_duration_unit = null;
      dynamicPerscriptionData.prescription_medicines[index].meal_duration_value = null;
    }
    setDynamicPerscriptionData({ ...dynamicPerscriptionData });
  };

  const handleDiagnosis = () => {
    setDiagnosisData([...diagnosisData, { pain_site:selectedSiteDiagnosis, provisionaldiagnosis: selectedDiagnosis, remark: diagnosisRemark }]);
    setSelectedDiagnosis('');
    setSelectedSiteDiagnosis(null);
    setDiagnosisRemark('');
  };
  const removeDiagnosis = (index) => {
    setDiagnosisData(diagnosisData.filter((_, i) => i !== index));
  };

  // handleDefDiagnosis
  const handleDefDiagnosis = () => {
    setDefDiagnosisData([...defDiagnosisData, { pain_site: selectedSiteDefDiagnosis, differentialdiagnosis: selectedDefDiagnosis, remark: diagnosisDefRemark }]);
    setSelectedDefDiagnosis(null);
    setSelectedSiteDefDiagnosis(null)
    setDiagnosisDefRemark('');
  };
  const removeDefDiagnosis = (index) => {
    setDefDiagnosisData(defDiagnosisData.filter((_, i) => i !== index));
  };

  const handleOnFocus = () => {
    let params = {
      page: 1,
    };
    ApiClient.getMedicines(params)
      .then((res) => {
        setMedicineList(res.data);
      })
      .catch((err) => console.log(err));
  };

  const createMedicines = () => {
    setMederror(null);
    setMedInfo(null);
    setIsLoading(true);
    console.log(valueObj);
    if (valueObj?.name && valueObj?.formulation) {
      ApiClient.createMedicines({ ...valueObj, pres: 1, status: 'transit' })
        .then((res) => {
          handleOnFocus();
          setValueObj({ name: '', formulation: null });
          setIsLoading(false);
          console.log(res);
          setAlertType('alert-success');
          setMedInfo('Medicine Created Successfully.');
        })
        .catch((err) => {
          setIsLoading(false);
          setAlertType('alert-danger');
          if (err.response.data.detail) {
            setIsShowAlert(err.response.data.detail);
          } else if (err.response.data.errors?.name) {
            const errMsg = err.response.data.errors.name[0] || '';
            if (errMsg.toLowerCase().includes('already exists')) {
              setMederror('The medicine already exists. Please search for it in the drop down.');
            } else {
              setMederror(err.response.data.errors.name);
            }
          } else {
            setMederror('Something went wrong!');
          }
          console.log(err);
        });
    } else {
      setMederror('Please fill mandatory fields');
    }
  };

  const renderInputBox = (item, error) => {
    return (
      <CoreInputBox
        disabled={isPublish}
        validateNumbers={item.type == 'number'}
        validatedecimal={item.type == 'float'}
        retuired={item?.required}
        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
        label={item.label}
        value={item.answer || ''}
        showMSG={error}
        setValue={(data) => {
          item.answer = data;
          setDynamicPerscriptionData({ ...dynamicPerscriptionData });
        }}
      />
    );
  };

  const checkOptionExit = (data, item) => {
    if (data && data?.length && !item.options.includes(data)) {
      item.searchData = data;
      setDynamicPerscriptionData({ ...dynamicPerscriptionData });
    } else {
      delete item.searchData;
      setDynamicPerscriptionData({ ...dynamicPerscriptionData });
    }
  };

  const addOptionInFields = (item, titleArray) => {
    let nonExitsString = titleArray.find((item2) => !item.options.includes(item2));
    if (nonExitsString) {
      let newOption = nonExitsString?.slice(6, nonExitsString.length);
      let apiData = {
        option: newOption,
        field_name: item?.name,
      };
      ApiClient.updateDepartmentFieldOption(selectedDepartment, apiData)
        .then((res) => {
          delete item.searchData;
          item.options = item.options + ' | ' + newOption;
          let oldAnswer = titleArray.filter((item2) => item2 != nonExitsString);
          oldAnswer.push(newOption);
          item.answer = oldAnswer.join('|');
          setDynamicPerscriptionData({ ...dynamicPerscriptionData });
        })
        .catch((err) => console.log(err));
    } else {
      item.answer = titleArray.join('|');
      setDynamicPerscriptionData({ ...dynamicPerscriptionData });
    }
  };

  const renderMultiSelectWithAdd = (item, error) => {
    let activeData = splitArrData(item?.answer?.toLowerCase(), '|');
    let arrData = splitArrObjData(item?.options, '|', 'title');
    if (item?.searchData?.length) {
      arrData.push({ title: 'Add : ' + item.searchData });
    }
    return (
      <div className='mb-3 capitalize'>
        <TagSelectPicker
          disabled={isPublish}
          showMSG={error}
          label={item.label}
          data={arrData}
          style={{ width: '100%' }}
          labelKey='title'
          valueKey='value'
          placeholder={item.label}
          onSelect={(val, titleArray) => {
            addOptionInFields(item, titleArray);
          }}
          onSearch={(data) => checkOptionExit(data, item)}
          msgStyle={{ color: 'red' }}
          value={activeData}
        />
      </div>
    );
  };

  const renderMultiSelect = (item, error) => {
    let activeData = splitArrData(item?.answer?.toLowerCase(), '|');
    let arrData = splitArrObjData(item?.options, '|', 'title');
    return (
      <div className='mb-3 capitalize'>
        <TagSelectPicker
          disabled={isPublish}
          showMSG={error}
          label={item.label}
          data={arrData}
          style={{ width: '100%' }}
          labelKey='title'
          valueKey='value'
          placeholder={item.label}
          onSelect={(val, titleArray) => {
            item.answer = titleArray.join('|');
            setDynamicPerscriptionData({ ...dynamicPerscriptionData });
          }}
          retuired={isNivanCareTeam && item?.required}
          msgStyle={{ color: 'red' }}
          value={activeData}
        />
      </div>
    );
  };

  const renderSingalSelect = (item, error) => {
    let arrData = splitArrObjData(item.options, '|', 'title');

    return (
      <Select2DropDown
        disabled={isPublish}
        value={item?.answer}
        data={arrData}
        label={item.label}
        placeholder={item.label}
        valueKey='value'
        labelKey='title'
        getObjData
        retuired={true}
        onSelect={(selectedValue, dataObj) => {
          item.answer = dataObj.title;
          setDynamicPerscriptionData({ ...dynamicPerscriptionData });
        }}
        showMSG={error}
      />
    );
  };

  const handleQuillKeyDown = (e, nextRef) => {
    if (e.key === 'Tab') {
      console.log(nextRef);
      e.preventDefault();
      nextRef.current?.focus();
    }
  };

  const renderInputDateField = (item, error) => {
    let defaultValue = '';
    if (item?.answer) {
      let date = new Date(item.answer);
      if (date != 'Invalid Date') {
        defaultValue = date;
      }
    }

    return (
      <div style={{ position: 'relative' }}>
        <div>
          <label class='inputlabel'>
            {item.required && <span class='requiredInput'> * </span>}
            {item.label}
          </label>
        </div>
        <DatePicker
          disabled={isPublish}
          disabledDate={(date) => {
            if (new Date(date) < new Date().setHours(0, 0, 0)) {
              return true;
            } else {
              return false;
            }
          }}
          defaultValue={defaultValue}
          preventOverflow
          format='yyyy-MM-dd'
          placeholder='YYYY-MM-DD'
          onChange={(date) => {
            item.answer = date;
            setDynamicPerscriptionData({ ...dynamicPerscriptionData });
          }}
          placement='autoVerticalStart'
          calendarDefaultDate={defaultValue || new Date()}
          onOk={(date) => {
            item.answer = date;
            setDynamicPerscriptionData({ ...dynamicPerscriptionData });
          }}
          style={{ width: '100%', padding: 0, margin: 0 }}
        />
        {error && <div class='inputMsg'>{error}</div>}
      </div>
    );
  };

  const renderPms = () => {
    // let renderData = () => {
    //   if (dynamicPerscriptionData?.prescription_schema) {
    //     return dynamicPerscriptionData?.prescription_schema.map((item, index) => {
    //       let fieldError = '';
    //       if (fieldErrors[index]) {
    //         fieldError = fieldErrors[index].answer;
    //       }
    //       return (
    //         <div key={index} className='w-100 mb-3'>
    //           {renderFields(item, fieldError)}
    //         </div>
    //       );
    //     });
    //   } else {
    //     return <div>No Record Found</div>;
    //   }
    // };

    return (
      <>
        {alertType == 'alert-danger' && (
          <CommonAlert
            className='mt-3'
            setIsShowAlert={setIsShowAlert}
            isShowAlert={isShowAlert}
            alertType={alertType}
            setAlertType={setAlertType}
            errorMessage={medicineError}
          />
        )}
        {/* <h5 className='card-title pt-2 pb-2'>PMS Investigation</h5> */}
        {/* Ankush */}
        <div className='row'>
          <div className='col-md-6'>
            <label class='inputlabel'>Presenting Complaints</label>
            <ReactQuill
              readOnly={isPublish}
              theme='snow'
              ref={principalRef}
              value={pms.principal_complaints}
              onChange={(value) => setPms((prevState) => ({ ...prevState, principal_complaints: value }))}
              onKeyDown={(e) => handleQuillKeyDown(e, painRef)}
            />
          </div>
          <div className='col-md-6'>
            <label class='inputlabel'>Treatment History</label>
            <ReactQuill
              readOnly={isPublish}
              theme='snow'
              ref={painRef}
              value={pms.pain_treatment_history}
              onChange={(value) => setPms((prevState) => ({ ...prevState, pain_treatment_history: value }))}
              onKeyDown={(e) => {
                if (e.key === 'Tab') {
                  e.preventDefault();
                  document.getElementById('pain_score_input')?.focus();
                }
              }}
            />
          </div>
        </div>

        <div className='row mt-3'>
          <div className='col-md-6'>
            <CoreInputBox
              disabled={isPublish}
              id={'pain_score_input'}
              retuired={false}
              labelStyle={{ fontWeight: 'var(--lightWeight)' }}
              label={`Pain Score (1 to 10)`}
              value={pms?.vas_score}
              showMSG={``}
              setValue={(data) => {
                if (data == '' || data <= 10) {
                  handleInputChange('pms', 'vas_score', data);
                }
              }}
            />
          </div>
        </div>
      </>
    );
  };

  const checkrequired = (data) => {
    let isErrors = false;
    let errors = [];

    data.map((item) => {
      if (item.required) {
        if (item.answer) {
          if (typeof item.answer == 'string' && item.answer.trim().length == 0) {
            errors.push({ answer: 'This field is required' });
            isErrors = true;
          } else {
            errors.push({});
          }
        } else {
          errors.push({ answer: 'This field is required' });
          isErrors = true;
        }
      } else {
        errors.push({});
      }
    });

    return { isErrors, errors };
  };

  // Scroll up to the first mandatory field that failed validation. Every input in this
  // form (CoreInputBox/CoreTextArea/Select2DropDown/CoreDropDown, plus the manually added
  // error blocks like Previous Investigation Done) renders its message in a `.inputMsg`
  // element only when there is an active error, so the first one in DOM order is the
  // first invalid field top-to-bottom on the page.
  const scrollToFirstError = () => {
    setTimeout(() => {
      const firstErrorEl = document.querySelector('.inputMsg');
      if (firstErrorEl) {
        firstErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  // Handle input change
  const handleInputChange = (state_name, name, data, isMulti = 0) => {
    if (state_name == 'pms') {
      // mdt_consults_advised
      if (isMulti == 1) {
        if (Array.isArray(data)) {
          const result = data.map((item) => item.value);
          setPms((prevPms) => ({
            ...prevPms,
            [name]: result,
          }));
        }
      } else {
        setPms((prevPms) => ({
          ...prevPms,
          [name]: data,
        }));
      }
    } else {
      setVital((prevVital) => ({
        ...prevVital,
        [name]: data,
      }));
    }
  };

  useEffect(() => {
    var inch = inches;
    if (inches == undefined || inches == '') {
      inch = 0;
    }
    console.log(weight, '=>', inch);
    if (weight && feet) {
      const totalInches = parseFloat(feet) * 12 + parseFloat(inch);
      const heightInMeters = (totalInches * 2.54) / 100;
      const calculatedBmi = weight / heightInMeters ** 2;
      setVital((prevVital) => ({
        ...prevVital,
        ['bmi']: calculatedBmi.toFixed(2),
      }));
    } else {
      setVital((prevVital) => ({
        ...prevVital,
        ['bmi']: 0,
      }));
    }
  }, [weight, feet, inches]);

  const renderFormDetails = () => {
    let defaultDateValue = '';
    if (pms?.next_checkin_date) {
      let date = new Date(pms?.next_checkin_date);
      if (date != 'Invalid Date') {
        defaultDateValue = date;
      }
    }
    return (
      <div style={{ 'margin-left': '50px', 'margin-right': '200px' }}>
        <form>
          {/* vital */}
          <div className='card mt-3'>
            <div className='card-body'>
              <div className='card-title pt-2 pb-2'>
                <h5>Vital Details
                  {/* {pafData && pid ?
                    <Button
                      appearance="ghost"
                      style={{"background-color":"#3287eb",float:"right"}}
                      className='btn btn-sm btn-success text-white'
                      size="sm"
                      onClick={() => syncFromPaf()}
                    >
                    Sync from PAF
                  </Button>
                  : null}  */}
                  
                </h5>
              </div>
              <div className='row'>
                <div className='col-md-3'>
                  <CoreInputBox
                    disabled={isPublish}
                    validateNumbers={false}
                    retuired={false}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`BP`}
                    value={vital?.bp}
                    showMSG={``}
                    setValue={(data) => {
                      handleInputChange('vitals', 'bp', data);
                    }}
                  />
                </div>
                <div className='col-md-3'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    validateNumbers={true}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Pulse`}
                    value={vital?.pulse}
                    showMSG={``}
                    setValue={(data) => {
                      handleInputChange('vitals', 'pulse', data);
                    }}
                  />
                </div>
                <div className='col-md-3'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    onlyNumAndDecimals={true}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Temperature in °F`}
                    value={vital?.temperature}
                    showMSG={``}
                    setValue={(data) => {
                      if (data === '' || Number(data) <= 110) {
                        handleInputChange('vitals', 'temperature', data);
                      }
                    }}
                  />
                </div>
                <div className='col-md-3'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    validateNumbers={true}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Respiration / min`}
                    value={vital?.respiration}
                    showMSG={``}
                    setValue={(data) => {
                      handleInputChange('vitals', 'respiration', data);
                    }}
                  />
                </div>
              </div>
              <div className='row mt-3'>
                <div className='col-md-3'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    validateNumbers={true}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Height in Feet (4 to 8)`}
                    value={vital?.height}
                    showMSG={``}
                    setValue={(data) => {
                      if (data == '' || (data >= 4 && data <= 8)) {
                        handleInputChange('vitals', 'height', data);
                        setFeet(data);
                      }
                    }}
                  />
                </div>
                <div className='col-md-3'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    validateNumbers={true}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Height in inches`}
                    value={vital?.height_inch}
                    showMSG={``}
                    setValue={(data) => {
                      if (data == '' || data <= 12) {
                        handleInputChange('vitals', 'height_inch', data);
                        setInches(data);
                      }
                    }}
                  />
                </div>
                <div className='col-md-3'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    onlyNumAndDecimals={true}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Weight kgs`}
                    value={vital?.weight}
                    showMSG={``}
                    setValue={(data) => {
                      if (data == '' || data <= 200) {
                        handleInputChange('vitals', 'weight', data);
                        setWeight(data);
                      }
                    }}
                  />
                </div>
                <div className='col-md-3'>
                  <CoreInputBox
                    retuired={false}
                    disabled={true}
                    // validateNumbers={true}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`BMI`}
                    value={vital?.bmi}
                    showMSG={``}
                    setValue={(data) => {
                      handleInputChange('vitals', 'bmi', data);
                    }}
                    inputStyle={{
                      color: vital?.bmi < 18.5 || vital?.bmi > 24.9 ? 'red' : 'blue',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* end vital */}
          <div className='card mt-3'>
            <div className='card-body'>{renderPms()}</div>
          </div>

          {/* Health Conditions */}
          <div className='card mt-3'>
            <div className='card-body'>
              {/* Health conditions */}
              <div className='row mt-3'>
                <div className='col-md-5'>
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Health conditions`}
                    </label>
                    <Select
                      isDisabled={isPublish}
                      defaultValue={healthCondition}
                      name={`Health conditions`}
                      options={healthConditionMaster}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setHealthCondition(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                {healthCondition ? (
                  <>
                    <div className='col-md-5'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={healthConditionRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setHealthConditionRemark(data);
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addHealthConditon)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addHealthConditon();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '40%' }}>Health Condition</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(healthConditionData) &&
                        healthConditionData.map((item, index) => (
                          <tr key={index}>
                            {editHCIndex === index ? (
                              <>
                                {/* EDIT MODE */}

                                <td>
                                  <Select
                                    isDisabled={isPublish}
                                    value={{
                                      label: item.healthCondition,
                                      value: item.healthCondition,
                                    }}
                                    options={healthConditionMaster}
                                    onChange={(v) =>
                                      updateHealthConditionField(index, "healthCondition", v?.value || "")
                                    }
                                  />
                                </td>

                                <td>
                                  <Input
                                    value={item.remark}
                                    onChange={(val) =>
                                      updateHealthConditionField(index, "remark", val)
                                    }
                                  />
                                </td>

                                <td>
                                  -
                                </td>
                              </>
                            ) : (
                              <>
                                <td>{item?.healthCondition}</td>
                                <td>{item.remark}</td>
                                <td>
                                  <div style={{ display: "flex", gap: "8px" }}>
                                    <Button
                                      appearance="ghost"
                                      size="sm"
                                      style={{"background-color":"#3287eb"}}
                                      className='btn btn-sm btn-primary text-white'
                                      disabled={isPublish}
                                      onClick={() => startEditHealthCondition(index)}
                                    >
                                      Edit
                                    </Button> 
                                    <CoreButton
                                      disabled={isPublish}
                                      customClass='btn btn-danger btn-sm'
                                      core_remove={1}
                                      title='Remove'
                                      onClick={(e) => {
                                        removeHealthCondition(index);
                                      }}
                                    />
                                  </div>
                                </td>
                              </>
                            )}
                            
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* end Health conditions */}
              {/* setRedAlertData */}
              <div className='row mt-3'>
                <div className='col-md-5'>
                  {/* <Select2DropDown
                      placement='auto'
                      value={redAlert}
                      data={redAlertMaster}
                      labelKey='name'
                      label={'Red Alert'}
                      placeholder={'Red Alert'}
                      valueKey='id'
                      getObjData
                      retuired
                      onSelect={(_, selectedValue) => {
                        setRedAlert(selectedValue?.id || '');
                      }}
                      showMSG={''}
                    /> */}
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Red Flags, If any`}
                    </label>
                    <Select
                      isDisabled={isPublish}
                      defaultValue={redAlert}
                      name={`Red Flags, If any`}
                      options={redAlertMaster}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setRedAlert(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                {redAlert ? (
                  <>
                    <div className='col-md-5'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={redAlertRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setRedAlertRemark(data);
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addRedAlert)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addRedAlert();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '40%' }}>Red Alert</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {redAlertData.map((item, index) => (
                        <tr key={index}>
                        {editRFIndex === index ? (
                          <>
                            {/* EDIT MODE */}
                  
                            <td>
                              <Select
                                isDisabled={isPublish}
                                value={{
                                  label: item.redAlert,
                                  value: item.redAlert,
                                }}
                                options={redAlertMaster}
                                onChange={(v) =>
                                  updateRedFlagField(index, "redAlert", v?.value || "")
                                }
                              />
                            </td>
                  
                            <td>
                              <Input
                                value={item.remark}
                                onChange={(val) =>
                                  updateRedFlagField(index, "remark", val)
                                }
                              />
                            </td>
                  
                            <td>
                              -
                            </td>
                          </>
                        ) : (
                          <>
                            <td>{item?.redAlert}</td>
                            <td>{item.remark}</td>
                            <td>
                              <div style={{ display: "flex", gap: "8px" }}>
                                  <Button
                                    appearance="ghost"
                                    size="sm"
                                    style={{"background-color":"#3287eb"}}
                                    className='btn btn-sm btn-primary text-white'
                                    onClick={() => startEditRedFlag(index)}
                                  >
                                    Edit
                                  </Button>
                                  <CoreButton
                                    customClass='btn btn-danger btn-sm'
                                    core_remove={1}
                                    title='Remove'
                                    onClick={(e) => {
                                      removeRedAlert(index);
                                    }}
                                  />
                                </div>
                            </td>
                          </>
                        )}
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* END Red alert */}

              <div className='row mt-3'>
                <div className='col-md-5'>
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Current Medications`}
                    </label>
                    <Select
                      isDisabled={isPublish}
                      style={{ 'z-index': 9999 }}
                      defaultValue={currentMedication}
                      name={`Current Medications`}
                      // onChange={setSelectedOption}
                      options={medications}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setCurrentMedication(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                {currentMedication ? (
                  <>
                    <div className='col-md-5'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={medicationRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setMedicationRemark(data);
                          // setDynamicPerscriptionData({ ...dynamicPerscriptionData });
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addMedication)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addMedication();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '40%' }}>Current Medication</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {medicationData.map((item, index) => (
                        <tr key={index}>
                          {editCurMedIndex === index ? (
                            <>
                              <td>
                                <Select
                                  style={{ 'z-index': 9999 }}
                                  // defaultValue={item.current_medication}
                                  value={{label: item.current_medication, value: item.current_medication}}
                                  // onChange={setSelectedOption}
                                  options={medications}
                                  isMulti={false}
                                  onChange={(selectedValue) => {
                                    updateCurrentMedField(index, "current_medication", selectedValue?.value || '')
                                  }}
                                />
                              </td>
                              <td>
                                <Input
                                  value={item.remark}
                                  onChange={(val) =>
                                    updateCurrentMedField(index, "remark", val)
                                  }
                                />
                              </td>
                              <td>-</td>
                            </>
                          ):(
                          <>
                          {item.current_medication == 'Other' ? (
                            <>
                              <td>{item.remark}</td>
                              <td>{``}</td>
                            </>
                          ) : (
                            <>
                              <td>{item.current_medication}</td>
                              <td>{item.remark}</td>
                            </>
                          )}

                          <td>
                            <div style={{ display: "flex", gap: "8px" }}>
                              <Button
                                appearance="ghost"
                                size="sm"
                                style={{"background-color":"#3287eb"}}
                                className='btn btn-sm btn-primary text-white'
                                onClick={() => startEditCurrentMed(index)}
                              >
                                Edit
                              </Button>
                              <CoreButton
                                customClass='btn btn-danger btn-sm'
                                core_remove={1}
                                title='Remove'
                                onClick={(e) => {
                                  removeMedication(index);
                                }}
                              />
                            </div>
                          </td>
                          </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Drug allergies */}

              <div className='row mt-3'>
                <div className='col-md-5'>
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Drug Allergies, if Any`}
                    </label>
                    <Select
                      isDisabled={isPublish}
                      defaultValue={drugA}
                      name={`Drug Allergies, if Any`}
                      options={allergiesMaster}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setDrugA(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                {drugA ? (
                  <>
                    <div className='col-md-5'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={drugRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setDrugRemark(data);
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addDrugData)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addDrugData();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '40%' }}>Drug Allergies</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(drugData) &&
                        drugData.map((item, index) => (
                          <tr key={index}>
                            {editDrugIndex === index ? (
                              <>
                                {/* EDIT MODE */}

                                <td>
                                  <Select
                                    isDisabled={isPublish}
                                    value={{ label: item.data, value: item.data }}
                                    options={allergiesMaster}
                                    onChange={(v) =>
                                      updateDrugAllergyField(index, "data", v?.value || "")
                                    }
                                  />
                                </td>

                                <td>
                                  <Input
                                    value={item.remark}
                                    onChange={(val) =>
                                      updateDrugAllergyField(index, "remark", val)
                                    }
                                  />
                                </td>

                                <td>
                                  -
                                </td>
                              </>
                            ) : (
                              <>
                                {item?.data == 'Other' ? (
                                  <>
                                    <td>{item?.remark}</td>
                                    <td>{``}</td>
                                  </>
                                ) : (
                                  <>
                                    <td>{item?.data}</td>
                                    <td>{item.remark}</td>
                                  </>
                                )}

                                <td>
                                  <div style={{ display: "flex", gap: "8px" }}>
                                    <Button
                                      appearance="ghost"
                                      size="sm"
                                      style={{"background-color":"#3287eb"}}
                                      className='btn btn-sm btn-primary text-white'
                                      onClick={() => startEditDrugAllergy(index)}
                                    >
                                      Edit
                                    </Button>

                                    <CoreButton
                                      customClass='btn btn-danger btn-sm'
                                      core_remove={1}
                                      title='Remove'
                                      onClick={(e) => {
                                        removeDrugData(index);
                                      }}
                                    />
                                  </div>
                                </td>
                              </>
                            )}
                            
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* end drug allergies */}
            </div>
          </div>

          {/* end Health Conditions */}

          {/* Investigation / Advice */}
          <div className='card mt-3'>
            <div className='card-body'>
              {/* <h5 className='card-title pt-2 pb-2'>Investigation / Advice</h5> */}
              {/* Previous Investigation Done - Radio Button */}
              <div className='row mb-3'>
                <div className='col-md-12'>
                  <label className='inputlabel'>
                    <span className='requiredInput'> * </span>Previous Investigation Done
                  </label>
                  <div className='d-flex gap-3 mt-2'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='previous_investigation_done'
                        id='investigation_yes'
                        value='yes'
                        checked={pms.previous_investigation_done === 'yes'}
                        onChange={(e) => {
                          setPms((prevState) => ({ ...prevState, previous_investigation_done: e.target.value }));
                          if (errors?.previous_investigation_done) {
                            setErrors((prev) => ({ ...prev, previous_investigation_done: '' }));
                          }
                        }}
                        disabled={isPublish}
                      />
                      <label className='form-check-label' htmlFor='investigation_yes'>
                        Yes
                      </label>
                    </div>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='previous_investigation_done'
                        id='investigation_no'
                        value='no'
                        checked={pms.previous_investigation_done === 'no'}
                        onChange={(e) => {
                          setPms((prevState) => ({ ...prevState, previous_investigation_done: e.target.value, previous_investigation_report: '' }));
                          if (errors?.previous_investigation_done) {
                            setErrors((prev) => ({ ...prev, previous_investigation_done: '' }));
                          }
                        }}
                        disabled={isPublish}
                      />
                      <label className='form-check-label' htmlFor='investigation_no'>
                        No
                      </label>
                    </div>
                  </div>
                  {errors?.previous_investigation_done && (
                    <div className='inputMsg' style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                      {errors.previous_investigation_done}
                    </div>
                  )}
                </div>
              </div>

              {/* Previous Investigation Report - Conditional Display */}
              {(pms.previous_investigation_done === 'yes' || pms.previous_investigation_report) && (
                <div className='row' ref={investigationReportRef}>
                  <div className='col-md-12'>
                    <label className='inputlabel'>
                      <span className='requiredInput'> * </span>Previous Investigation Report
                    </label>
                    <ReactQuill
                      readOnly={isPublish}
                      theme='snow'
                      value={pms.previous_investigation_report}
                      onChange={(value) => {
                        setPms((prevState) => ({ ...prevState, previous_investigation_report: value }));
                        // Clear error when user starts typing
                        if (errors?.previous_investigation_report) {
                          setErrors((prev) => ({ ...prev, previous_investigation_report: '' }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Tab') {
                          e.preventDefault();
                          document.getElementById('react-select-6-input')?.focus();
                        }
                      }}
                    />
                    {errors?.previous_investigation_report && (
                      <div className='inputMsg' style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                        {errors.previous_investigation_report}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Investigations Prescribed */}
          <div className='card mt-3'>
            <div className='card-body'>
              <h5 className='card-title pt-2 pb-2'>Investigations Prescribed</h5>
              <div className='row mt-3'>
                <div className='col-md-5'>
                  {/* <Select2DropDown
                      placement='auto'
                      value={test}
                      data={investigationsTest}
                      labelKey='name'
                      label={'Tests'}
                      placeholder={'Tests'}
                      valueKey='id'
                      getObjData
                      retuired
                      onSelect={(_, selectedValue) => {
                        setTest(selectedValue?.id || '');
                      }}
                      showMSG={''}
                    /> */}
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Tests`}
                    </label>
                    <Select
                      isDisabled={isPublish}
                      defaultValue={test}
                      name={`Tests`}
                      // onChange={setSelectedOption}
                      options={investigationsTest}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setTest(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                {test ? (
                  <>
                    <div className='col-md-5'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={testRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setTestRemark(data);
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addTest)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addTest();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '40%' }}>Test</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {investigationData.map((item, index) => (
                        <tr key={index}>
                          {editTestIndex === index ? (
                            <>
                              {/* TEST - SELECT */}
                              <td>
                                <Select
                                  isDisabled={isPublish}
                                  value={
                                    item.investigationtests
                                      ? { label: item.investigationtests, value: item.investigationtests }
                                      : null
                                  }
                                  options={investigationsTest}
                                  onChange={(v) =>
                                    updateTestField(index, "investigationtests", v?.value || "")
                                  }
                                />
                              </td>

                              {/* REMARK */}
                              <td>
                                <Input
                                  value={item.remark}
                                  onChange={(val) => updateTestField(index, "remark", val)}
                                />
                              </td>

                              {/* ACTION */}
                              <td>
                               -
                              </td>
                            </>
                          ) : (
                            <>
                            {item?.test == 'Other' || item?.investigationtests == 'Other' ? (
                            <>
                              <td>{item.remark}</td>
                              <td>{``}</td>
                            </>
                          ) : (
                            <>
                            {/* investigationtests */}
                              <td>{item?.test || item?.investigationtests}</td>
                              <td>{item.remark}</td>
                            </>
                          )}
                          <td>
                            <div style={{ display: "flex", gap: "8px" }}>
                              <Button
                                appearance="ghost"
                                size="sm"
                                style={{"background-color":"#3287eb"}}
                                className='btn btn-sm btn-primary text-white'
                                onClick={() => startEditTest(index)}
                              >
                                Edit
                              </Button>
                              <CoreButton
                                customClass='btn btn-danger btn-sm'
                                core_remove={1}
                                title='Remove'
                                onClick={(e) => {
                                  removeTest(index);
                                }}
                              />
                            </div>
                          </td>
                            </>
                          )}
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-5'>
                  {/* <Select2DropDown
                      placement='auto'
                      value={imaging}
                      data={investigationImaging}
                      labelKey='name'
                      label={'Imaging'}
                      placeholder={'Imaging'}
                      valueKey='id'
                      getObjData
                      retuired
                      onSelect={(_, selectedValue) => {
                        setImgaging(selectedValue?.id || '');
                      }}
                      showMSG={''}
                    /> */}
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Imaging`}
                    </label>
                    <Select
                      isDisabled={isPublish}
                      defaultValue={imaging}
                      name={`Imaging`}
                      options={investigationImaging}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setImgaging(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                {imaging ? (
                  <>
                    <div className='col-md-5'>
                      <CoreInputBox
                        disabled={isPublish}
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={imagingRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setImgagingRemark(data);
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addImaging)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        disabled={isPublish}
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addImaging();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '40%' }}>Imaging</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {imagingData.map((item, index) => (
                        <tr key={index}>
                        {editImgIndex === index ? (
                          <>
                            {/* IMAGING - SELECT */}
                            <td>
                              <Select
                                value={
                                  item.investigationimaging
                                    ? { label: item.investigationimaging, value: item.investigationimaging }
                                    : null
                                }
                                options={investigationImaging}
                                onChange={(v) =>
                                  updateImagingField(index, "investigationimaging", v?.value || "")
                                }
                              />
                            </td>
                  
                            {/* REMARK */}
                            <td>
                              <Input
                                value={item.remark}
                                onChange={(val) => updateImagingField(index, "remark", val)}
                              />
                            </td>
                  
                            {/* ACTION */}
                            <td>
                              -
                            </td>
                          </>
                        ) : (
                          <>
                              {item?.image === "Other" || item?.investigationimaging === "Other" ? (
                              <>
                                <td>{item.remark}</td>
                                <td>{``}</td>
                              </>
                            ) : (
                              <>
                                {/* <td>{item?.image}</td> */}
                                <td>{item?.image || item?.investigationimaging}</td>
                                {/* investigationimaging */}
                                <td>{item.remark}</td>
                              </>
                            )}
                            <td>
                              <div style={{ display: "flex", gap: "8px" }}>
                                <Button
                                  appearance="ghost"
                                  size="sm"
                                  style={{"background-color":"#3287eb"}}
                                  className='btn btn-sm btn-primary text-white'
                                  disabled={isPublish}
                                  onClick={() => startEditImaging(index)}
                                >
                                  Edit
                                </Button>
                                  <CoreButton
                                    disabled={isPublish}
                                    customClass='btn btn-danger btn-sm'
                                    core_remove={1}
                                    title='Remove'
                                    onClick={(e) => {
                                      removeImaging(index);
                                    }}
                                  />
                                </div>
                            </td>
                          </>
                        )}
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* end Investigation / Advice */}

          {/* Diagnosis */}

          <div className='card mt-3'>
            <div className='card-body'>
              {/* Differential Diagnosis */}
              <div className='row mt-3'>
                {/* painSite */}
                <div className='col-md-3'>
                    <>
                      <label className='inputlabel'>
                        {/* <span className='requiredInput'> * </span> */}
                        {`Pain Site (Differential Diagnosis)`} 
                      </label>
                      <Select
                        isDisabled={isPublish}
                        defaultValue={selectedSiteDefDiagnosis || null}
                        name={`Pain Site`}
                        // onChange={setSelectedOption}
                        options={painSite}
                        isMulti={false}
                        onChange={(selectedValue) => {
                          setEditDefDiagnosisIndex(null)
                          const site = selectedValue?.value;
                          setSelectedSiteDefDiagnosis(site);
                        
                          const options = (diagnosisMasterData[site] || []).map(item => ({
                            label: item,
                            value: item,
                          }));
                        
                          setDiagnosisMaster(options);
                          setSelectedDefDiagnosis("");
                        }}
                       
                      />
                    </>
                </div>
                <div className='col-md-3'>
                  {selectedSiteDefDiagnosis && (
                    <>
                      <label className='inputlabel'>
                        {/* <span className='requiredInput'> * </span> */}
                        {`Differential Diagnosis`}
                      </label>
                      <Select
                        isDisabled={isPublish}
                        defaultValue={selectedDefDiagnosis || null}
                        name={`Differential Diagnosis`}
                        // onChange={setSelectedOption}
                        options={diagnosisMaster}
                        isMulti={false}
                        onChange={(selectedValue) => {
                          setSelectedDefDiagnosis(selectedValue?.value || '');
                          // setCurrentPage(1);
                          // getListData(selectedValue?.id || '', 1);
                        }}
                      />
                    </>
                  )}
                </div>
                {selectedDefDiagnosis ? (
                  <>
                    <div className='col-md-4'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={diagnosisDefRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setDiagnosisDefRemark(data);
                          // setDynamicPerscriptionData({ ...dynamicPerscriptionData });
                        }}
                        onKeyDown={(e) => handleEnterPress(e, handleDefDiagnosis)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          handleDefDiagnosis();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-2'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '20%' }}>Pain Site</th>
                        <th style={{ width: '30%' }}>Differential Diagnosis Name</th>
                        <th style={{ width: '40%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {defDiagnosisData.map((item, index) => (
                        <tr key={index}>
                          {editDefDiagnosisIndex === index ? (
                            <>
                            {/* Pain Site dropdown */}
                            <td>
                              <Select
                                value={{ label: item.pain_site, value: item.pain_site }}
                                options={painSite}
                                onChange={(v) => {
                                  const site = v?.value;
                                  const options = (diagnosisMasterData[site] || []).map(item => ({
                                    label: item,
                                    value: item,
                                  }));
                                
                                  setDiagnosisMaster(options);
                                  setSelectedDefDiagnosis("");
                                  updateDefDiagnosisField(index, "pain_site", v.value)
                                }
                                }
                              />
                            </td>
                  
                            {/* Diagnosis dropdown */}
                            <td>
                              <Select
                                value={{ label: item.differentialdiagnosis, value: item.differentialdiagnosis }}
                                options={diagnosisMaster}
                                onChange={(v) =>
                                  updateDefDiagnosisField(index, "differentialdiagnosis", v.value)
                                }
                              />
                            </td>
                  
                            {/* Remark text field */}
                            <td>
                              <Input
                                value={item.remark}
                                onChange={(val) => updateDefDiagnosisField(index, "remark", val)}
                              />
                            </td>
                            <td>-</td>
                          </>
                          ) : (
                          <>
                          <td>{item?.pain_site == "Other" ? "" : item?.pain_site}</td>
                          {item?.differentialdiagnosis == "Other" 
                            ?
                              <>
                              <td>{item.remark}</td>
                              <td></td>
                              
                              </>
                            :
                              <>
                              <td>{item?.diagnosis || item?.differentialdiagnosis}</td>
                              <td>{item.remark}</td>
                              </>
                          }
                          
                          <td>
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <Button
                                  appearance="ghost"
                                  style={{"background-color":"#3287eb"}}
                                  className='btn btn-sm btn-primary text-white'
                                  size="sm"
                                  disabled={isPublish}
                                  onClick={() => startEditDefDiagnosis(item, index, item?.pain_site)}
                                >
                                  Edit
                                </Button>
                                <CoreButton
                                  disabled={isPublish}
                                  customClass='btn btn-danger btn-sm'
                                  core_remove={1}
                                  title='Remove'
                                  onClick={(e) => {
                                    removeDefDiagnosis(index);
                                  }}
                                />
                              </div>
                          </td>
                          </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* end Differential Diagnosis */}
              {/* Provisional Diagnosis */}
              <div className='row mt-3'>
                {/* painSite */}
                <div className='col-md-3'>
                    <>
                      <label className='inputlabel'>
                        {/* <span className='requiredInput'> * </span> */}
                        {`Pain Site (`}{pms?.is_final ? `Final Diagnosis` : `Provisional Diagnosis`}{`)`}
                      </label>
                      <Select
                        isDisabled={isPublish}
                        defaultValue={selectedSiteDefDiagnosis || null}
                        name={`Pain Site`}
                        // onChange={setSelectedOption}
                        options={painSite}
                        isMulti={false}
                        onChange={(selectedValue) => {
                          setEditDiagnosisIndex(null)
                          const site = selectedValue?.value;
                          setSelectedSiteDiagnosis(site);
                        
                          const options = (diagnosisMasterData[site] || []).map(item => ({
                            label: item,
                            value: item,
                          }));
                        
                          setDiagnosisMaster(options);
                          setSelectedDiagnosis("");
                        }}
                       
                      />
                    </>
                </div>
                <div className='col-md-3'>
                  {selectedSiteDiagnosis && (
                    <>
                      <label className='inputlabel'>
                        {/* <span className='requiredInput'> * </span> */}
                        {pms?.is_final ? `Final Diagnosis` : `Provisional Diagnosis`}
                        {/* {`Provisional Diagnosis`} */}
                      </label>
                      <Select
                        defaultValue={selectedDiagnosis}
                        name={`Provisional Diagnosis`}
                        // onChange={setSelectedOption}
                        options={diagnosisMaster}
                        isMulti={false}
                        onChange={(selectedValue) => {
                          setSelectedDiagnosis(selectedValue?.value || '');
                        }}
                      />
                    </>
                  )}
                </div>
                {selectedDiagnosis ? (
                  <>
                    <div className='col-md-4'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={diagnosisRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setDiagnosisRemark(data);
                          // setDynamicPerscriptionData({ ...dynamicPerscriptionData });
                        }}
                        onKeyDown={(e) => handleEnterPress(e, handleDiagnosis)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          handleDiagnosis();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '20%' }}>Pain Site</th>
                        <th style={{ width: '30%' }}>{pms?.is_final ? `Final Diagnosis Name` : `Provisional Diagnosis Name`}</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {diagnosisData.map((item, index) => (
                        <tr key={index}>
                          {editDiagnosisIndex === index ? (
                            <>
                            {/* Pain Site dropdown */}
                            <td>
                              <Select
                                value={{ label: item.pain_site, value: item.pain_site }}
                                options={painSite}
                                onChange={(v) => {
                                  const site = v?.value;
                                  const options = (diagnosisMasterData[site] || []).map(item => ({
                                    label: item,
                                    value: item,
                                  }));
                                
                                  setDiagnosisMaster(options);
                                  setSelectedDiagnosis("");
                                  updateDiagnosisField(index, "pain_site", v.value)
                                }
                                }
                              />
                            </td>
                  
                            {/* Diagnosis dropdown */}
                            <td>
                              <Select
                                value={{ label: item.provisionaldiagnosis, value: item.provisionaldiagnosis }}
                                options={diagnosisMaster}
                                onChange={(v) =>
                                  updateDiagnosisField(index, "provisionaldiagnosis", v.value)
                                }
                              />
                            </td>
                  
                            {/* Remark text field */}
                            <td>
                              <Input
                                value={item.remark}
                                onChange={(val) => updateDiagnosisField(index, "remark", val)}
                              />
                            </td>
                            <td>-</td>
                          </>
                          ) : (
                          <>
                            <td>{item?.pain_site == "Other" ? "" : item?.pain_site}</td>
                            {/* <td>{item.diagnosis}</td> */}
                            {item?.provisionaldiagnosis == "Other" ? 
                            <>
                            <td>{item.remark}</td>
                            <td></td>
                            </>

                            :
                            <>
                            <td>{item?.diagnosis || item?.provisionaldiagnosis}</td>
                            <td>{item.remark}</td>
                            </>
                            }
                            
                            
                            <td>
                              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <Button
                                  appearance="ghost"
                                  style={{"background-color":"#3287eb"}}
                                  className='btn btn-sm btn-primary text-white'
                                  size="sm"
                                  disabled={isPublish}
                                  onClick={() => startEditDiagnosis(item, index, item?.pain_site)}
                                >
                                  Edit
                                </Button>

                                <CoreButton
                                  disabled={isPublish}
                                  customClass="btn btn-danger btn-sm"
                                  core_remove={1}
                                  title="Remove"
                                  onClick={() => removeDiagnosis(index)}
                                />
                              </div>
                              {/* <Button appearance="ghost" size="sm" onClick={() => startEditDiagnosis(item, index,item?.pain_site)}>
                                Edit
                              </Button>
                              <CoreButton
                                customClass='btn btn-danger btn-sm'
                                core_remove={1}
                                title='Remove'
                                onClick={(e) => {
                                  removeDiagnosis(index);
                                }}
                              /> */}
                            </td>
                          </>
                          )}
                          
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* end Provisional Diagnosis */}

              <div className='w-100 p-2'>
                <div className='d-flex  form-check '>
                  <input
                    style={{ cursor: 'pointer' }}
                    className='form-check-input'
                    type='checkbox'
                    value={pms?.is_final}
                    checked={pms?.is_final === true}
                    id='flexCheckDefault'
                    disabled={isPublish}
                    onChange={(event) => handleInputChange('pms', 'is_final', event.target.checked)}
                  />
                  <label style={{ cursor: 'pointer' }} className='ms-2 form-check-label' htmlFor='flexCheckDefault'>
                    Mark as final diagnosis
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* end Diagnosis */}

          {/* Treatment */}
          <div className='card mt-3'>
            <div className='card-body'>
              <h5 className='card-title pt-2 pb-2'>Rx : Treatment / Advice</h5>
              <div className='row mt-3'>
                {/* Pain site */}
                <div className='col-md-3'>
                    <>
                      <label className='inputlabel'>
                        {/* <span className='requiredInput'> * </span> */}
                        {`Pain Site (Treatment Procedure)`}
                      </label>
                      <Select
                        isDisabled={isPublish}
                        defaultValue={selectedSiteDiagnosis || null}
                        name={`Pain Site`}
                        // onChange={setSelectedOption}
                        options={painSite}
                        isMulti={false}
                        onChange={(selectedValue) => {
                          const site = selectedValue?.value;
                          setTreatmentSite(site);
                        
                          const options = (treatmentMasterData[site] || []).map(item => ({
                            label: item,
                            value: item,
                          }));
                          setEditTPIndex(null);
                          setTreatmentMaster(options);
                          setTreatmentProcedure("");
                        }}
                       
                      />
                    </>
                </div>
                {treatmentSite ? (
                <div className='col-md-3'>
                  {/* <Select2DropDown
                      placement='auto'
                      value={treatmentProcedure}
                      data={treatmentMaster}
                      labelKey='name'
                      label={'Treatment Procedure'}
                      placeholder={'Treatment Procedure'}
                      valueKey='id'
                      getObjData
                      retuired
                      onSelect={(_, selectedValue) => {
                        setTreatmentProcedure(selectedValue?.id || '');
                      }}
                      showMSG={''}
                    /> */}
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Treatment Procedure`}
                    </label>
                    <Select
                      defaultValue={treatmentProcedure}
                      name={`Treatment Procedure`}
                      options={treatmentMaster}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setTreatmentProcedure(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                )
                :
                null
                }
                {treatmentProcedure ? (
                  <>
                    <div className='col-md-4'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Procedure Remark`}
                        value={treatmentProcedureRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setTreatmentProcedureRemark(data);
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addTreatmentProcedure)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addTreatmentProcedure();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '20%' }}>Pain Site</th>
                        <th style={{ width: '30%' }}>Treatment Procedure</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    {treatmentProcedureData.map((item, index) => (
                      <tr key={index}>
                        {editTPIndex === index ? (

                            <>
                              {/* EDIT MODE – always show all fields */}
                              <td>
                                <Select
                                  value={{ label: item.pain_site, value: item.pain_site }}
                                  options={painSite}
                                  onChange={(v) =>{
                                    const site = v?.value;
                                    const options = (treatmentMasterData[site] || []).map(item => ({
                                      label: item,
                                      value: item,
                                    }));
                                  
                                    setTreatmentMaster(options);
                                    updateTPField(index, "pain_site", v.value)
                                  }
                                    
                                  }
                                />
                              </td>

                              <td>
                                <Select
                                  value={{
                                    label: item.treatment || item.treatmentprocedure,
                                    value: item.treatment || item.treatmentprocedure,
                                  }}
                                  options={treatmentMaster}
                                  onChange={(v) =>
                                    updateTPField(index, "treatment", v.value)
                                  }
                                />
                              </td>

                              <td>
                                <Input
                                  value={item.remark}
                                  onChange={(val) => updateTPField(index, "remark", val)}
                                />
                              </td>

                              <td>
                                -
                              </td>
                            </>
                          ) : (
                            <>
                            
                                {item?.treatment == 'Other' || item?.treatmentprocedure == 'Other' ? (
                                  <>
                                    <td>{item?.pain_site == "Other" ? "" : item?.pain_site}</td>
                                    <td>{item.remark}</td>
                                    <td>{``}</td>
                                  </>
                                ) : (
                                  <>
                                    <td>{item?.pain_site == "Other" ? "" : item?.pain_site}</td>
                                    {/* <td>{item?.treatment}</td> */}
                                    <td>{item?.treatment || item?.treatmentprocedure}</td>
                                    <td>{item.remark}</td>
                                  </>
                                )}
                                <td>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Button
                                      appearance="ghost"
                                      size="sm"
                                      style={{"background-color":"#3287eb"}}
                                      className='btn btn-sm btn-primary text-white'
                                      disabled={isPublish}
                                      onClick={() => startEditTP(index,item?.pain_site)}
                                    >
                                      Edit
                                    </Button>
                                      <CoreButton
                                        disabled={isPublish}
                                        customClass='btn btn-danger btn-sm'
                                        core_remove={1}
                                        title='Remove'
                                        onClick={(e) => {
                                          removeTreatmentProcedure(index);
                                        }}
                                      />
                                  </div>
                                </td>
                             
                            </>
                            )}
                             </tr>
                        ))}
                         
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-5'>
                  {/* <Select2DropDown
                      placement='auto'
                      value={treatmentOther}
                      data={treatmentOtherMaster}
                      labelKey='name'
                      label={'Treatment Other'}
                      placeholder={'Treatment Other'}
                      valueKey='id'
                      getObjData
                      retuired
                      onSelect={(_, selectedValue) => {
                        setTreatmentOther(selectedValue?.id || '');
                      }}
                      showMSG={''}
                    /> */}
                  <>
                    <label className='inputlabel'>
                      {/* <span className='requiredInput'> * </span> */}
                      {`Treatment Other`}
                    </label>
                    <Select
                      isDisabled={isPublish}
                      style={{ 'z-index': 9999 }}
                      defaultValue={treatmentOther}
                      name={`Treatment Other`}
                      options={treatmentOtherMaster}
                      isMulti={false}
                      onChange={(selectedValue) => {
                        setTreatmentOther(selectedValue?.value || '');
                      }}
                    />
                  </>
                </div>
                {treatmentOther ? (
                  <>
                    <div className='col-md-5'>
                      <CoreInputBox
                        retuired={false}
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`Remark`}
                        value={treatmentOtherRemark}
                        showMSG={``}
                        setValue={(data) => {
                          setTreatmentOtherRemark(data);
                        }}
                        onKeyDown={(e) => handleEnterPress(e, addTreatmentOther)}
                      />
                    </div>
                    <div className='col-md-2'>
                      <CoreButton
                        customClass='btn btn-secondary btn-sm'
                        title='Add'
                        onClick={(e) => {
                          addTreatmentOther();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '40%' }}>Treatment</th>
                        <th style={{ width: '50%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {treatmentOtherData.map((item, index) => (
                        <tr key={index}>
                          {editTOIndex === index ? (
                            <>
                              {/* EDIT MODE */}

                              {/* Treatment Other (textbox) */}
                              <td>
                                <Select
                                    style={{ zIndex: 9999 }}
                                    value={{
                                      label: item.treatmentother,
                                      value: item.treatmentother,
                                    }}
                                    name="Treatment Other"
                                    options={treatmentOtherMaster}
                                    isMulti={false}
                                    onChange={(v) =>
                                      updateTreatmentOtherField(index, "treatmentother", v?.value || "")
                                    }
                                  />
                                
                              </td>

                              {/* Remark (textbox) */}
                              <td>
                                <Input
                                  value={item.remark}
                                  onChange={(val) =>
                                    updateTreatmentOtherField(index, "remark", val)
                                  }
                                />
                              </td>

                              {/* Action Buttons */}
                              <td>
                                -
                              </td>
                            </>
                          ) : (
                          <>
                            {item?.treatment == 'Other' || item?.treatmentother == 'Other' ? (
                              <>
                                <td>{item.remark}</td>
                                <td>{``}</td>
                              </>
                            ) : (
                              <>
                                {/* <td>{item?.treatment}</td> */}
                                <td>{item?.treatment || item?.treatmentother}</td>
                                <td>{item.remark}</td>
                              </>
                            )}

                            <td>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Button
                                  appearance="ghost"
                                  size="sm"
                                  style={{"background-color":"#3287eb"}}
                                  className='btn btn-sm btn-primary text-white'
                                  disabled={isPublish}
                                  onClick={() => startEditTreatmentOther(index)}
                                >
                                  Edit
                                </Button>
                                <CoreButton
                                  disabled={isPublish}
                                  customClass='btn btn-danger btn-sm'
                                  core_remove={1}
                                  title='Remove'
                                  onClick={(e) => {
                                    removeTreatmentOther(index);
                                  }}
                                />
                              </div>
                            </td>
                          </>
                          )}
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* end Treatment */}

          {/* Treatment Medication */}
          <div className='card mt-3'>
            <div className='card-body'>
              <div className='card-title pt-2 pb-2'>
                <h5>Medicines</h5>
                <small>
                  <a style={{ color: 'blue', cursor: 'pointer' }} onClick={openModal}>
                    Create Medicine
                  </a>
                </small>
              </div>
              <div className='row' style={{ 'z-index': 0 }}>
                <div className='col-md-3' style={{ 'z-index': 0 }}>
                  <Select2DropDown
                    disabled={isPublish}
                    placement='auto'
                    onSearch={(query) => searchMedicines(query, 0)}
                    value={treatmentMed?.medication}
                    data={medicineList}
                    labelKey='name'
                    label={'Medication'}
                    placeholder={'Medication'}
                    valueKey='name'
                    retuired={false}
                    searchBy={(keyword, label, item) => {
                      const lowerKeyword = keyword.toLowerCase();
                      return (
                        (item?.name || '').toLowerCase().includes(lowerKeyword) ||
                        (item?.shorter_composition || '').toLowerCase().includes(lowerKeyword)
                      );
                    }}
                    onSelect={(_, selectedValue) => {
                      setTreatmentMed((prevState) => ({ ...prevState, medication: selectedValue?.name || '' }));
                      setTreatmentMed((prevState) => ({ ...prevState, medication_id: selectedValue?.id || '' }));
                      setTreatmentMed((prevState) => ({ ...prevState, shorter_composition: selectedValue?.shorter_composition || '' }));
                    }}
                    showMSG={''}
                  />
                  {treatmentMed?.shorter_composition && (
                    <div style={{ fontSize: '10px', color: '#666', marginTop: '3px', fontStyle: 'italic' }}>
                      {treatmentMed.shorter_composition}
                    </div>
                  )}
                  {/* <CoreInputBox
                                  retuired={false}
                                  labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                                  label={`Medication`}
                                  value={treatmentMed?.medication}
                                  showMSG={``}
                                  setValue={(data) => setTreatmentMed(prevState => ({ ...prevState, medication: data.toUpperCase() }))}
                          /> */}
                </div>
                {/* <div className='col-md-2'>
                        <CoreInputBox
                                  retuired={false}
                                  labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                                  label={`Brand if, any`}
                                  value={treatmentMed?.brand}
                                  showMSG={``}
                                  setValue={(data) => setTreatmentMed(prevState => ({ ...prevState, brand: data }))}
                          />
                    </div> */}
                <div className='col-md-2' style={{ 'z-index': 0 }}>
                  <Select2DropDown
                    disabled={isPublish}
                    placement='auto'
                    value={treatmentMed?.regimen}
                    data={[
                          { id: '0-0-1', name: '0-0-1' },
                          { id: '0-1-0', name: '0-1-0' },
                          { id: '0-1-1', name: '0-1-1' },
                          { id: '1-0-0', name: '1-0-0' },
                          { id: '1-0-1', name: '1-0-1' },
                          { id: '1-1-0', name: '1-1-0' },
                          { id: '1-1-1', name: '1-1-1' },

                          { id: '1/2-1/2-1/2', name: '1/2-1/2-1/2' },
                          { id: '1/2-0-1/2', name: '1/2-0-1/2' },
                          { id: '1/2-0-0', name: '1/2-0-0' },
                          { id: '0-0-1/2', name: '0-0-1/2' },
                          { id: '0-1/2-0', name: '0-1/2-0' },

                          { id: 'SOS', name: 'SOS' },
                          { id: 'Other', name: 'Other' },
                        ]}
                    labelKey='name'
                    label={'Regimen'}
                    placeholder={'Regimen'}
                    valueKey='id'
                    retuired={false}
                    onSelect={(_, selectedValue) => {
                      setTreatmentMed((prevState) => ({ ...prevState, regimen: selectedValue?.id || '' }));
                    }}
                    showMSG={''}
                  />
                  {/* <>
                          <label className='inputlabel'>
                            <span className='requiredInput'> * </span>{`Regimen`}
                          </label>
                          <Select
                            defaultValue={treatmentOther}
                            name={`Regimen`}
                            options={[{"value":"0-0-1","label":"0-0-1"},{"value":"0-1-0","label":"0-1-0"},{"value":"0-1-1","label":"0-1-1"},{"value":"1-0-0","label":"1-0-0"},{"value":"1-0-1","label":"1-0-1"},{"value":"1-1-0","label":"1-1-0"},{"value":"1-1-1","label":"1-1-1"},{"value":"Other","label":"Other"}]}
                            isMulti = {false}
                            onChange={(selectedValue) => {
                              setTreatmentMed(prevState => ({ ...prevState, regimen: selectedValue?.value || '' }))
                            }}
                            />
                        </> */}
                </div>
                {treatmentMed?.regimen == 'Other' ? (
                  <div className='col-md-2'>
                    <CoreInputBox
                      disabled={isPublish}
                      retuired={false}
                      labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                      label={`Other Regimen`}
                      value={treatmentMed?.other_regimen}
                      showMSG={``}
                      setValue={(data) => setTreatmentMed((prevState) => ({ ...prevState, other_regimen: data }))}
                    />
                  </div>
                ) : null}

                <div className='col-md-2' style={{ 'z-index': 0 }}>
                  <Select2DropDown
                    disabled={isPublish}
                    placement='auto'
                    value={treatmentMed?.meal}
                    data={[
                      { id: 'After meal', name: 'After meal' },
                      { id: 'Before meal', name: 'Before meal' },
                      { id: 'Empty stomach', name: 'Empty stomach' },
                      { id: 'NA', name: 'NA' },
                    ]}
                    labelKey='name'
                    label={'meal'}
                    placeholder={'Meal'}
                    valueKey='id'
                    retuired={false}
                    onSelect={(_, selectedValue) => {
                      setTreatmentMed((prevState) => ({ ...prevState, meal: selectedValue?.id || '' }));
                    }}
                    showMSG={''}
                  />
                </div>
                <div className='col-md-1'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Duration`}
                    value={treatmentMed?.duration}
                    showMSG={``}
                    setValue={(data) => setTreatmentMed((prevState) => ({ ...prevState, duration: data }))}
                  />
                </div>
                <div className='col-md-2'>
                  <CoreInputBox
                    disabled={isPublish}
                    retuired={false}
                    labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                    label={`Remark`}
                    value={treatmentMed?.remark}
                    showMSG={``}
                    setValue={(data) => setTreatmentMed((prevState) => ({ ...prevState, remark: data }))}
                    onKeyDown={(e) => handleEnterPress(e, addTreatmentMed)}
                  />
                </div>
                <div className='col-md-2'>
                  <CoreButton
                    disabled={isPublish}
                    customClass='btn btn-secondary btn-sm'
                    title='Add'
                    onClick={(e) => {
                      addTreatmentMed();
                    }}
                  />
                </div>
              </div>
              <span style={{ color: 'red' }}>{treatmentMedErr}</span>
              {/* treatmentMedData */}
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <table className='table table-bordered table-hover'>
                    <thead>
                      <tr style={{ 'background-color': '#e9efff' }}>
                        <th style={{ width: '8%' }}>S. No.</th>
                        <th style={{ width: '35%' }}>Medication</th>

                        <th style={{ width: '10%' }}>Regimen</th>
                        <th style={{ width: '20%' }}>Meal</th>
                        <th style={{ width: '10%' }}>Duration</th>
                        <th style={{ width: '35%' }}>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {treatmentMedData.map((item, index) => (
                        <tr key={index}>
                          {editMedIndex === index ? (
                            <>
                              {/* EDIT MODE */}

                              {/* S. No */}
                              <td>{index + 1}</td>

                              {/* Medication (TEXTBOX only) */}
                              <td>
                                <Input
                                  value={item.medication}
                                  onChange={(val) => updateMedicineField(index, "medication", val)}
                                />
                              </td>

                              {/* Regimen */}
                              <td>
                                <Select2DropDown
                                  value={item.regimen}
                                  data={[
                                    { id: '0-0-1', name: '0-0-1' },
                                    { id: '0-1-0', name: '0-1-0' },
                                    { id: '0-1-1', name: '0-1-1' },
                                    { id: '1-0-0', name: '1-0-0' },
                                    { id: '1-0-1', name: '1-0-1' },
                                    { id: '1-1-0', name: '1-1-0' },
                                    { id: '1-1-1', name: '1-1-1' },

                                    { id: '1/2-1/2-1/2', name: '1/2-1/2-1/2' },
                                    { id: '1/2-0-1/2', name: '1/2-0-1/2' },
                                    { id: '1/2-0-0', name: '1/2-0-0' },
                                    { id: '0-0-1/2', name: '0-0-1/2' },
                                    { id: '0-1/2-0', name: '0-1/2-0' },

                                    { id: 'SOS', name: 'SOS' },
                                    { id: 'Other', name: 'Other' },
                                  ]}
                                  labelKey='name'
                                  placeholder={'Regimen'}
                                  valueKey='id'
                                  retuired={false}
                                  onSelect={(_, selectedValue) => {
                                    updateMedicineField(index, "regimen", selectedValue?.id || '');
                                  }}
                                 
                                />
                              </td>

                              {/* Meal */}
                              <td>
                                <Select2DropDown
                                  value={item.meal}
                                  data={[
                                    { id: 'After meal', name: 'After meal' },
                                    { id: 'Before meal', name: 'Before meal' },
                                    { id: 'Empty stomach', name: 'Empty stomach' },
                                    { id: 'NA', name: 'NA' },
                                  ]}
                                  labelKey='name'
                                  // label={'meal'}
                                  placeholder={'Meal'}
                                  valueKey='id'
                                  retuired={false}
                                  onSelect={(_, selectedValue) => {
                                    updateMedicineField(index, "meal", selectedValue?.id || '');
                                  }}
                                  
                                />
                              </td>

                              {/* Duration */}
                              <td>
                                <Input
                                  type="number"
                                  value={item.duration}
                                  onChange={(val) => updateMedicineField(index, "duration", val)}
                                />
                              </td>

                              {/* Remark */}
                              <td>
                                <Input
                                  value={item.remark}
                                  onChange={(val) => updateMedicineField(index, "remark", val)}
                                />
                              </td>

                              {/* Action Buttons */}
                              <td>
                                -
                              </td>
                            </>
                          ) : (
                          <>
                            <td>{index+1}</td>
                            <td>
                              {item?.medication}
                              {item?.shorter_composition && (
                                <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic', marginTop: '2px' }}>
                                  {item.shorter_composition}
                                </div>
                              )}
                            </td>
                            <td>{item?.regimen == 'Other' ? item?.other_regimen : item?.regimen}</td>
                            <td>{item?.meal}</td>

                            <td>{item?.duration}</td>
                            <td>{item.remark}</td>
                            <td>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Button
                                  appearance="ghost"
                                  size="sm"
                                  style={{"background-color":"#3287eb"}}
                                  className='btn btn-sm btn-primary text-white'
                                  disabled={isPublish}
                                  onClick={() => startEditMedicine(index)}
                                >
                                  Edit
                                </Button>
                                <CoreButton
                                  disabled={isPublish}
                                  customClass='btn btn-danger btn-sm'
                                  core_remove={1}
                                  title='Remove'
                                  onClick={(e) => {
                                    removeTreatmentMed(index);
                                  }}
                                />
                              </div>
                            </td>
                          </>
                          )}
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* end Treatment Medication */}

          {/* Other Section */}
          <div className='card mt-3'>
            <div className='card-body'>
              {/* <h5 className='card-title pt-2 pb-2'>Other Section</h5> */}
              <div className='row mt-3'>
                <div className='col-md-6'>
                  <label class='inputlabel'>
                    {/* <span class='requiredInput'> * </span> */}
                    Next Check-in Date
                  </label>

                  <DatePicker
                    disabled={isPublish}
                    disabledDate={(date) => {
                      if (new Date(date) < new Date().setHours(0, 0, 0)) {
                        return true;
                      } else {
                        return false;
                      }
                    }}
                    value={pms?.next_checkin_date ? new Date(`${pms.next_checkin_date}`) : null}
                    // defaultValue={defaultDateValue || new Date()}
                    preventOverflow
                    format='yyyy-MM-dd'
                    placeholder='YYYY-MM-DD'
                    onChange={(date) => {
                      if (date && date instanceof Date && !isNaN(date.getTime())) {
                        const formattedDate = date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD
                        handleInputChange('pms', 'next_checkin_date', formattedDate);
                      }
                    }}
                    placement='autoVerticalStart'
                    calendarDefaultDate={defaultDateValue || new Date()}
                    onOk={(date) => {
                      if (date && date instanceof Date && !isNaN(date.getTime())) {
                        const formattedDate = date.toISOString().split('T')[0]; // Format properly
                        handleInputChange('pms', 'next_checkin_date', formattedDate);
                      }
                    }}
                    style={{ width: '100%', padding: 0, margin: 0 }}
                  />
                </div>
                {userRole != 'doctor' ? (
                  <div className='col-md-6'>
                    <label class='inputlabel'>
                      {/* <span class='requiredInput'> * </span> */}
                      OPD Booking Date & Time
                    </label>

                    <DatePicker
                      disabled={isPublish}
                      value={pms?.opd_booking_date ? new Date(`${pms.opd_booking_date}`) : null}
                      // defaultValue={defaultDateValue || new Date()}
                      preventOverflow
                      format='yyyy-MM-dd HH:mm'
                      placeholder='YYYY-MM-DD HH:MM'
                      onChange={(date) => {
                        const formattedDate = date.toISOString();
                        handleInputChange('pms', 'opd_booking_date', formattedDate);
                      }}
                      placement='autoVerticalStart'
                      calendarDefaultDate={defaultDateValue || new Date()}
                      onOk={(date) => {
                        const formattedDate = date.toISOString();
                        handleInputChange('pms', 'opd_booking_date', formattedDate);
                      }}
                      style={{ width: '100%', padding: 0, margin: 0 }}
                    />
                  </div>
                ) : null}
              </div>

              <div className='row mt-3'>
                <div className='col-md-6'>
                  <Select2DropDown
                    disabled={isPublish}
                    placement='auto'
                    value={isMdt}
                    data={[
                      { id: 'Yes', name: 'Yes' },
                      { id: 'No', name: 'No' },
                      { id: 'External Consult', name: 'External Consult' },
                    ]}
                    labelKey='name'
                    label={'MDT consults advised'}
                    placeholder={'MDT consults advised'}
                    valueKey='id'
                    retuired={false}
                    onSelect={(_, selectedValue) => {
                      setIsMdt(selectedValue?.id || '');
                      if (selectedValue?.id == 'No') {
                        handleInputChange('pms', 'mdt_consults_advised', '');
                      } else if (selectedValue?.id == 'External Consult') {
                        handleInputChange('pms', 'mdt_consults_advised', 'External Consult');
                      }
                    }}
                    showMSG={''}
                  />
                </div>
                {pms?.mdt_consults_advised && pms?.mdt_consults_advised == 'External Consult' && (
                  <>
                    <div className='col-md-6'>
                      <CoreInputBox
                        validateNumbers={false}
                        retuired={false}
                        placeholder='Enter external consultation referred'
                        labelStyle={{ fontWeight: 'var(--lightWeight)' }}
                        label={`External Consultations Referred`}
                        value={pms?.external_consultation_referred}
                        setValue={(value) => {
                          handleInputChange('pms', 'external_consultation_referred', value);
                        }}
                      />
                      <>
                        {/* <label className='inputlabel'>
                          <span className='requiredInput'> * </span>
                          {`MDT`}
                        </label> */}
                        <Select2DropDown
                          placement='auto'
                          retuired={true}
                          value={pms?.external_consultation}
                          label={'MDT'}
                          name={`MDT`}
                          data={external}
                          valueKey='id'
                          labelKey='name'
                          isMulti={false}
                          onSelect={(_, selectedValue) => {
                            handleInputChange('pms', 'external_consultation', selectedValue?.id || '');
                          }}
                        />
                        
                      </>
                    </div>
                  </>
                )}

                {isMdt == 'Yes' ? (
                  <div className='col-md-6'>
                    <>
                      <label className='inputlabel'>
                        <span className='requiredInput'> * </span>
                        {`MDT`}
                      </label>
                      <Select
                        isDisabled={isPublish}
                        // defaultValue={pms?.mdt_consults_advised}
                        // defaultValue={mdtMaster.filter(option =>
                        //   pms?.mdt_consults_advised?.some(item => item === option.value)
                        // )}
                        defaultValue={mdtMaster.filter(
                          (option) => Array.isArray(pms?.mdt_consults_advised) && pms?.mdt_consults_advised.some((item) => item === option.value)
                        )}
                        name={`MDT`}
                        options={mdtMaster}
                        isMulti={true}
                        onChange={(selectedValue) => {
                          handleInputChange('pms', 'mdt_consults_advised', selectedValue, 1);
                        }}
                      />
                    </>
                  </div>
                ) : null}
              </div>

              <br />
              <br />
            </div>
          </div>
          {/* Other Section */}

          {/* {dynamicPerscriptionData?.enable_medicine && renderNestingFields()} */}
          {/* {createMedicineModal()} */}

          <Modal backdrop='static' size='md' open={open} onClose={handleModalClose}>
            <Modal.Header>
              <Modal.Title>Create Medicine</Modal.Title>
            </Modal.Header>
            {/* <Modal.Body> */}
            <div className='row mt-3'>
              <div className='col-md-6'>
                <CoreInputBox
                  placeholder='Medicine Name'
                  value={valueObj?.name || ''}
                  label='Medicine Name'
                  setValue={(inputVal) => {
                    setValueObj({ ...valueObj, name: inputVal });
                  }}
                  maxLength={255}
                  msgStyle={{ color: 'red' }}
                  retuired
                />
              </div>
              <div className='col-md-6'>
                <Select2DropDown
                  value={valueObj?.formulation || ''}
                  data={formulationData()}
                  labelKey='title'
                  label={'Medicine Formulation'}
                  placeholder={'Medicine Formulation'}
                  valueKey='id'
                  retuired
                  onSelect={(inputVal) => {
                    if (inputVal && inputVal != '') {
                      setValueObj({ ...valueObj, formulation: inputVal });
                    } else {
                      // delete valueObj.formulation;
                      setValueObj({ ...valueObj, formulation: null });
                    }
                  }}
                />
              </div>
            </div>
            <br />

            <div style={{ color: 'green' }}>{medInfo}</div>
            <div style={{ color: 'red' }}>{medError}</div>
            <div className='row mt-3'>
              <CoreButton
                onClick={() => {
                  createMedicines();
                }}
                title={'Save'}
              />
            </div>
            {/* </Modal.Body> */}
          </Modal>

          {/* Compare Transcribed Medicines */}
          <Modal backdrop='static' size='lg' open={medCompareOpen} onClose={closeMedCompareModal}>
            <Modal.Header>
              <Modal.Title>Confirm Transcribed Medicines</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p style={{ color: '#555', marginBottom: '16px' }}>
                These medicines were detected from the recording. Compare each one against similar matches from the medicine list and pick the correct one.
              </p>
              {medCompareItems.map((entry, index) => (
                <div key={index} className='card mb-3' style={{ border: '1px solid #e0e0e0' }}>
                  <div className='card-body'>
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                      <strong>Medicine {index + 1}</strong>
                      <span className='text-muted' style={{ fontSize: '12px' }}>
                        {entry.original.regimen} · {entry.original.meal} · {entry.original.duration} days
                      </span>
                    </div>
                    <div className='d-flex flex-wrap' style={{ gap: '10px' }}>
                      <div
                        onClick={() => selectMedCompareOption(index, 'original')}
                        style={{
                          border: `2px solid ${entry.selectedKey === 'original' ? '#0d47a1' : '#ddd'}`,
                          borderRadius: '10px',
                          padding: '12px',
                          minWidth: '220px',
                          cursor: 'pointer',
                          background: entry.selectedKey === 'original' ? '#eaf1fc' : '#fff',
                        }}
                      >
                        <div style={{ fontSize: '11px', color: '#0d47a1', fontWeight: 600, marginBottom: '4px' }}>
                          TRANSCRIBED
                        </div>
                        <div style={{ fontWeight: 600 }}>{entry.original.medication}</div>
                        <div style={{ fontSize: '12px', color: '#8a96a3' }}>
                          {entry.original.shorter_composition || 'No composition available'}
                        </div>
                      </div>

                      {entry.matches.map((match) => (
                        <div
                          key={match.id}
                          onClick={() => selectMedCompareOption(index, String(match.id))}
                          style={{
                            border: `2px solid ${entry.selectedKey === String(match.id) ? '#0d47a1' : '#ddd'}`,
                            borderRadius: '10px',
                            padding: '12px',
                            minWidth: '220px',
                            cursor: 'pointer',
                            background: entry.selectedKey === String(match.id) ? '#eaf1fc' : '#fff',
                          }}
                        >
                          <div style={{ fontSize: '11px', color: '#2e7d32', fontWeight: 600, marginBottom: '4px' }}>
                            MASTER LIST MATCH
                          </div>
                          <div style={{ fontWeight: 600 }}>{match.name}</div>
                          <div style={{ fontSize: '12px', color: '#8a96a3' }}>
                            {match.shorter_composition || 'No composition available'}
                          </div>
                        </div>
                      ))}

                      {entry.matches.length === 0 && (
                        <div style={{ fontSize: '12px', color: '#8a96a3', alignSelf: 'center' }}>
                          No similar matches found.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button appearance='subtle' onClick={closeMedCompareModal}>
                Cancel
              </Button>
              <Button
                appearance='primary'
                style={{ backgroundColor: '#0d47a1', borderColor: '#0d47a1' }}
                onClick={applyMedicineComparisons}
              >
                Confirm Selection
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Additional Note */}
          <div className='card mt-3'>
            <div className='card-body'>
              <div className='card-title pt-2 pb-2'>
                <h5>Additional Note</h5>
              </div>

              <ReactQuill
                readOnly={isPublish}
                theme='snow'
                value={pms?.additional_note || ''}
                onChange={(value) => {
                  handleInputChange('pms', 'additional_note', value);
                }}
                placeholder='Additional Note by Doctor...'
              />
            </div>
          </div>
          {/* Internal Note */}
          <div className='card mt-3'>
            <div className='card-body'>
              <div className='card-title pt-2 pb-2'>
                <h5>Internal Note</h5>
              </div>

              <Input
                disabled={isPublish}
                as='textarea'
                rows={3}
                placeholder='Internal Note by Doctor...'
                onChange={(value) => {
                  handleInputChange('pms', 'internal_note', value);
                }}
                value={pms?.internal_note || ''}
              />
            </div>
          </div>
          {/* end medicine */}
          {isPublish ?
            <CoreButton
              disabled={true}
              customClass='btn btn-secondary btn-lg'
              title='Published!'
            />
           : 
            <CoreButton
              onClick={() => {
                setErrors({ prescription_medicines: [] });
                setFieldErrors([]);
                let prescription_data = {
                  is_new: 1,
                };

                if (dynamicPerscriptionData?.prescription_schema) {
                  prescription_data.data = dynamicPerscriptionData.prescription_schema;
                }

                if (dynamicPerscriptionData?.enable_medicine) {
                  prescription_data.prescription_medicines = dynamicPerscriptionData.prescription_medicines;
                }

                if (diagnosisData) {
                  prescription_data.diagnosis_data = diagnosisData;
                }
                if (defDiagnosisData) {
                  prescription_data.def_diagnosis_data = defDiagnosisData;
                }
                if (vital) {
                  prescription_data.vital_data = vital;
                }
                if (pms) {
                  prescription_data.pms_data = pms;
                }
                if (healthConditionData) {
                  prescription_data.pms_data.health_condition = healthConditionData;
                }
                if (drugData) {
                  prescription_data.pms_data.drug_allergies = drugData;
                }

                if (medicationData) {
                  prescription_data.medication_data = medicationData;
                }
                if (investigationData) {
                  prescription_data.investigation_data = investigationData;
                }
                if (treatmentProcedureData) {
                  prescription_data.treatment_procedure_data = treatmentProcedureData;
                }
                if (treatmentOtherData) {
                  prescription_data.treatment_other_data = treatmentOtherData;
                }
                if (imagingData) {
                  prescription_data.imaging_data = imagingData;
                }
                if (redAlertData) {
                  prescription_data.red_alert = redAlertData;
                }
                if (treatmentMedData) {
                  prescription_data.treatment_medication = treatmentMedData;
                }
                let checkIserror = checkrequired(prescription_data.imaging_data);

                // Previous Investigation Done (Yes/No) is mandatory
                if (pms.previous_investigation_done !== 'yes' && pms.previous_investigation_done !== 'no') {
                  setErrors((prev) => ({ ...prev, previous_investigation_done: 'Previous Investigation Done is required' }));
                  checkIserror.isErrors = true;
                }

                // Validate Previous Investigation Report if Previous Investigation Done is "yes"
                if (pms.previous_investigation_done === 'yes') {
                  const reportText = pms.previous_investigation_report?.replace(/<[^>]*>/g, '').trim(); // Strip HTML tags and trim
                  if (!reportText || reportText === '') {
                    setErrors((prev) => ({ ...prev, previous_investigation_report: 'Previous Investigation Report is required when Investigation Done is Yes' }));
                    checkIserror.isErrors = true;
                    // Scroll to the investigation report field
                    setTimeout(() => {
                      investigationReportRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }, 100);
                  }
                }

                if (checkIserror.isErrors) {
                  setFieldErrors(checkIserror.errors);
                  scrollToFirstError();
                } else {
                  onClick(prescription_data);
                }
              }}
              customClass='btn btn-secondary btn-lg'
              title='Save Details'
            />
          }
          
        </form>
      </div>
    );
  };

  return <div className='prescription-form'>{renderFormDetails()}</div>;
}

export default AddPrescriptionPMSForm;
